import Vue from 'vue';
import Vuex from 'vuex';
import validation from './modules/validation.js';
import { answerService } from '@/services/answerService';
import { utilityService } from '@/services/utilityService';
import { authTokenService } from '@/services/authTokenService';
import { CONSTANTS } from '@/common/constants';
import { ValueService } from 'ag-grid-community';
import { platform } from 'chart.js';
import { identity, join } from 'lodash';

Vue.use(Vuex);
const survey = {
	state: {
		/** Dictionary key: qId, value: Array of answer objects */
		answers: {},
		count: 0,
		/** True if the survey is currently saving */
		isSaving: false,
		/** True if the survey question is loading matrix changes */
		isLoading: false,
		/** Holds the timestamp for the last save */
		lastSavedTimeStamp: null,
		singleanswer: {},
		standardSurvey: false,
		questionId: 0
	},
	mutations: {
		setAnswers (state, { qId, answerArray }) {
			// Must use Vue.set to update the map. Changes cannot be observed on properties that don't exist at initialization
			// Using this Vue.set method adds the item and hooks up the observation.
			Vue.set(state.answers, qId, answerArray);
		},
		// explicit method for mutating the answer object, does not need to be called right now because modifying the object returned from
		// the getter seems to have the same functionality.
		updateAnswer (state, { qId, index, key, value }) {
			if (state.answers[qId] != null) {
				state.answers[qId][index][key] = value;
			}
		},
		setIsSaving (state, { isSaving }) {
			state.isSaving = isSaving
		},
		setIsLoading (state, { isLoading }) {
			state.isLoading = isLoading;
		},
		setLastSaved (state, { lastSavedTimeStamp }) {
			state.lastSavedTimeStamp = lastSavedTimeStamp;
		},
		setIsSurveyType (state, { isStandardSurvey }) {
			state.standardSurvey = isStandardSurvey;
		},
		setquestionId (state, { questionId }) {
			state.questionId = questionId;
		}
	},
	actions: {
		loadAnswers (context, payload) {
			var returnEmpty = 'false';

			// Load answer(s) for the question(s) in this section
			answerService.loadAnswer(payload.activeId, payload.qId, returnEmpty).then(function (response) {
				debugger;
				if (response && response.data) {
					context.commit('setAnswers', { qId: payload.qId, answerArray: response.data });
				}
			})
				.catch(function (e) {
					console.log(e);
					if (e.message.includes('404')) {
						returnEmpty = 'true';

						answerService.loadAnswer(payload.activeId, payload.qId, returnEmpty).then(function (response) {
							if (response && response.data) {
								// TODO: This sets status, change once the status values are implemented
								for (var i = 0; i < response.data.length; i++) {
									response.data[i].status = 'Incomplete';
								}
								context.commit('setAnswers', { qId: payload.qId, answerArray: response.data });
							}
						})
							.catch(function (e) {
								console.log(e);
								throw e;
							});
					}
					throw e;
				});
		},
		loadAllAnswers (context, { surveyId, qId }) {
			debugger;
			console.log('calling..');
			answerService.loadAllAnswers(surveyId, qId).then(function (response) {
				if (response && response.data) {
					var keyArray = Object.keys(response.data);
					keyArray.forEach(function (key) {
						context.commit('setAnswers', { qId: key, answerArray: response.data[key] });
					});
				}
			})
				.catch(function (e) {
					console.log(e);
				});
		},
		saveAll (context) {
			debugger;
			context.commit('setIsSaving', { isSaving: true });
			if (context.state.answers) {
				answerService.saveAnswers(context.state.answers, true).then(function (response) {
					// response.data needs to have validation messages and question statuses
					// For now make new calls to load the updated statuses and validations
					context.dispatch('validation/loadSurveyValidationMessages');
					context.dispatch('validation/loadQuestionStatuses');

					context.commit('setIsSaving', { isSaving: false });
					context.commit('setIsLoading', { isLoading: false });
					context.commit('setLastSaved', { lastSavedTimeStamp: utilityService.getTimeStamp() });
				}).catch(function (response) {
					console.error(response);
					context.commit('setIsSaving', { isSaving: false });
					context.commit('setIsLoading', { isLoading: false });
					context.commit('setLastSaved', { lastSavedTimeStamp: 'There was an error saving' });
				});
			}
		},
		/**
		 * Saves all survey answers but does not run validations, update validation messages, or update question statuses.
		 */
		autoSaveAll (context) {
			context.commit('setIsSaving', { isSaving: true });
			if (context.state.answers) {
				answerService.saveAnswers(context.state.answers, false).then(function (response) {
					context.commit('setIsSaving', { isSaving: false });
					context.commit('setIsLoading', { isLoading: false });
					context.commit('setLastSaved', { lastSavedTimeStamp: utilityService.getTimeStamp() });
				}).catch(function (response) {
					console.error(response);
					context.commit('setIsSaving', { isSaving: false });
					context.commit('setIsLoading', { isLoading: false });
					context.commit('setLastSaved', { lastSavedTimeStamp: 'There was an error saving' });
				});
			}
		},
		/**
		 * Saves the question answer and runs the questions validations. On success response trigger a reload of
		 * the survey validation messages and survey question statuses.
		 */
		saveQuestion (context, {
			qId, expval, expval2, fy1Con, fy1Pla, isStandardSurvey
		}) {
      debugger;
			var answersOfCountries = "";
			var array = [];
			if (!isStandardSurvey && qId == 16) {
				if (answersOfCountries.length != context.state.answers[qId].length)
					array = answersOfCountries;
				else
					array = context.state.answers[qId];
			} else if (isStandardSurvey && qId == 14) {
				if (answersOfCountries.length != context.state.answers[qId].length)
					array = answersOfCountries;
				else
					array = context.state.answers[qId];
			}
			else
				array = context.state.answers[qId];

		  for (var i = 0; i < Object.keys(array[0]).length; i++) {
			   if (qId == 2) {
					if (Object.keys(array[0])[i] == "expBox1")
					{
						Object.values(array[0])[i] = expval;
						array[0].expBox1 = expval;
					}
					if (Object.keys(array[0])[i] == "expBox2")
					{
						Object.values(array[0])[i] = expval2;
						array[0].expBox2 = expval2;
					}
			   }
			   else if (qId != 2)
			   {
					if (qId == 4) {
						if (Object.keys(array[0])[i] == "fy1Con") {
							Object.values(array[0])[i] = fy1Con;
							array[0].fy1Con = fy1Con;
						}
						if (Object.keys(array[0])[i] == "fy1Pla") {
							Object.values(array[0])[i] = fy1Pla;
							array[0].fy1Pla = fy1Pla;
						}
					}

					if (!isStandardSurvey && (qId == 7 || qId == 17))
					{
						for (var j = 0; j < Object.keys(array[0].a).length; j++)
						{
							if (Object.keys(array[0].a)[i] == "expBox")
							{
								Object.values(array[0].a)[i] = expval;
								if(array[0].a.expBox != null)
								{
									array[0].a.expBox=expval.replace(/(\[.*?);(.*?\])/g, '$1$2');
									array[0].a.expBox=expval.replace(/  +/g, ' ');
								}
								else
									array[0].a.expBox=expval;
							}
						}
					}

					if (isStandardSurvey && (qId == 6 || qId == 15)) {
						for (var j = 0; j < Object.keys(array[0].a).length; j++)
						{
							if (Object.keys(array[0].a)[i] == "expBox") {
								Object.values(array[0].a)[i] = expval;
								if (array[0].a.expBox != null) {
									array[0].a.expBox = expval.replace(/(\[.*?);(.*?\])/g, '$1$2');
									array[0].a.expBox = expval.replace(/  +/g, ' ');
								} else {
									array[0].a.expBox = expval;
								}
							}
						}
					} else if (Object.keys(array[0])[i] == "expBox") {
						Object.values(array[0])[i] = expval;
						if (expval != null) {
							array[0].expBox = expval.replace(/(\[.*?);(.*?\])/g, '$1$2');
							array[0].expBox = expval.replace(/  +/g, ' ');
						} else {
							array[0].expBox = expval;
						}
					}
			   }
			}
			//This below condition, to add totals for a specific questions
			if (isStandardSurvey) {
				if (qId == 1 || qId == 3)	{
					array[0].fy1Tot = array[0].fy1Con + array[0].fy1Pla;
					array[0].fy2Tot = array[0].fy2Con + array[0].fy2Pla;
					if (qId == 1)	{
						document.getElementById('fy1Tot_0_1').value = array[0].fy1Tot.toLocaleString();
						document.getElementById('fy2Tot_1_1').value = array[0].fy2Tot.toLocaleString();
					}
					if (qId == 3) {
						document.getElementById('fy1Tot_0_3').value = array[0].fy1Tot.toLocaleString();
						document.getElementById('fy2Tot_1_3').value = array[0].fy2Tot.toLocaleString();
					}
				}
				if (qId == 2)	{
					var fy1Con01 = document.getElementById('fy1Con_0_1').value;
					var fy1Con01InNumber = parseFloat(fy1Con01.replaceAll(',', ''));
					var diff1 = parseFloat(fy1Con01InNumber - array[0].fy1Con);
					document.getElementById('fy1Con_undefined_2').value = diff1.toLocaleString();
					var fy1Pla01 = document.getElementById('fy1Pla_0_1').value;
					var fy1Pla01InNumber = parseFloat(fy1Pla01.replaceAll(',', ''));
					var diff2 = parseFloat(fy1Pla01InNumber - array[0].fy1Pla);
					document.getElementById('fy1Pla_undefined_2').value = diff2.toLocaleString();
				}
				if (qId == 5)	{
					array[0].fy1Tot = array[0].fy1Bas + array[0].fy1App + array[0].fy1Exp;
					array[0].fy2Tot = array[0].fy2Bas + array[0].fy2App + array[0].fy2Exp;

					document.getElementById('fy1Tot_0_5').value = array[0].fy1Tot.toLocaleString();
					document.getElementById('fy2Tot_1_5').value = array[0].fy2Tot.toLocaleString();
				}
				if (qId == 6 || qId == 15) {
					//a
					array[0].a.totCis = array[0].a.bascCis + array[0].a.apldCis + array[0].a.epCis;
					if (qId == 6)
						document.getElementById('totCis_3_6').value = array[0].a.totCis;
					else if (qId == 15)
						document.getElementById('totCis_3_15').value = array[0].a.totCis;
					//b
					array[0].b.totAtm = array[0].b.basAtm + array[0].b.appAtm + array[0].b.expAtm;
					array[0].b.totGeo = array[0].b.basGeo + array[0].b.appGeo + array[0].b.expGeo;
					array[0].b.totOce = array[0].b.basOce + array[0].b.appOce + array[0].b.expOce;
					array[0].b.totEnvrnNec = array[0].b.bascEnvrnNec + array[0].b.apldEnvrnNec + array[0].b.epEnvrnNec;
					if (qId == 6)	{
						document.getElementById('totAtm_3_6').value = array[0].b.totAtm.toLocaleString();
						document.getElementById('totGeo_3_6').value = array[0].b.totGeo.toLocaleString();
						document.getElementById('totOce_3_6').value = array[0].b.totOce.toLocaleString();
						document.getElementById('totEnvrnNec_3_6').value = array[0].b.totEnvrnNec.toLocaleString();
					}	else if (qId == 15)	{
						document.getElementById('totAtm_3_15').value = array[0].b.totAtm.toLocaleString();
						document.getElementById('totGeo_3_15').value = array[0].b.totGeo.toLocaleString();
						document.getElementById('totOce_3_15').value = array[0].b.totOce.toLocaleString();
						document.getElementById('totEnvrnNec_3_15').value = array[0].b.totEnvrnNec.toLocaleString();
					}
					array[0].b.bascEnvrnTot = array[0].b.basAtm + array[0].b.basGeo + array[0].b.basOce + array[0].b.bascEnvrnNec;
					array[0].b.apldEnvrnTot = array[0].b.appAtm + array[0].b.appGeo + array[0].b.appOce + array[0].b.apldEnvrnNec;
					array[0].b.epEnvrnTot = array[0].b.expAtm + array[0].b.expGeo + array[0].b.expOce + array[0].b.epEnvrnNec;
					array[0].b.totEnvrnTot = array[0].b.bascEnvrnTot + array[0].b.apldEnvrnTot + array[0].b.epEnvrnTot;
					if (qId == 6)	{
						document.getElementById('bascEnvrnTot_0_6').value = array[0].b.bascEnvrnTot.toLocaleString();
						document.getElementById('apldEnvrnTot_1_6').value = array[0].b.apldEnvrnTot.toLocaleString();
						document.getElementById('epEnvrnTot_2_6').value = array[0].b.epEnvrnTot.toLocaleString();
						document.getElementById('totEnvrnTot_3_6').value = array[0].b.totEnvrnTot.toLocaleString();
					} else if (qId == 15) {
						document.getElementById('bascEnvrnTot_0_15').value = array[0].b.bascEnvrnTot.toLocaleString();
						document.getElementById('apldEnvrnTot_1_15').value = array[0].b.apldEnvrnTot.toLocaleString();
						document.getElementById('epEnvrnTot_2_15').value = array[0].b.epEnvrnTot.toLocaleString();
						document.getElementById('totEnvrnTot_3_15').value = array[0].b.totEnvrnTot.toLocaleString();
					}
					//c
					array[0].c.totAgr = array[0].c.basAgr + array[0].c.appAgr + array[0].c.expAgr;
					array[0].c.totLifeBio = array[0].c.bascLifeBio + array[0].c.apldLifeBio + array[0].c.epLifeBio;
					array[0].c.totHea = array[0].c.basHea + array[0].c.appHea + array[0].c.expHea;
					array[0].c.totNat = array[0].c.basNat + array[0].c.appNat + array[0].c.expNat;
					array[0].c.totLifeNec = array[0].c.bascLifeNec + array[0].c.apldLifeNec + array[0].c.epLifeNec;
					if (qId == 6)	{
						document.getElementById('totAgr_3_6').value = array[0].c.totAgr.toLocaleString();
						document.getElementById('totLifeBio_3_6').value = array[0].c.totLifeBio.toLocaleString();
						document.getElementById('totHea_3_6').value = array[0].c.totHea.toLocaleString();
						document.getElementById('totNat_3_6').value = array[0].c.totNat.toLocaleString();
						document.getElementById('totLifeNec_3_6').value = array[0].c.totLifeNec.toLocaleString();
					} else if (qId == 15) {
						document.getElementById('totAgr_3_15').value = array[0].c.totAgr.toLocaleString();
						document.getElementById('totLifeBio_3_15').value = array[0].c.totLifeBio.toLocaleString();
						document.getElementById('totHea_3_15').value = array[0].c.totHea.toLocaleString();
						document.getElementById('totNat_3_15').value = array[0].c.totNat.toLocaleString();
						document.getElementById('totLifeNec_3_15').value = array[0].c.totLifeNec.toLocaleString();
					}
					array[0].c.bascLifeTot = array[0].c.basAgr + array[0].c.bascLifeBio + array[0].c.basHea + array[0].c.basNat + array[0].c.bascLifeNec;
					array[0].c.apldLifeTot = array[0].c.appAgr + array[0].c.apldLifeBio + array[0].c.appHea + array[0].c.appNat + array[0].c.apldLifeNec;
					array[0].c.epLifeTot = array[0].c.expAgr + array[0].c.epLifeBio + array[0].c.expHea + array[0].c.expNat + array[0].c.epLifeNec;
					array[0].c.totLifeTot = array[0].c.bascLifeTot + array[0].c.apldLifeTot + array[0].c.epLifeTot;
					if (qId == 6) {
						document.getElementById('bascLifeTot_0_6').value = array[0].c.bascLifeTot.toLocaleString();
						document.getElementById('apldLifeTot_1_6').value = array[0].c.apldLifeTot.toLocaleString();
						document.getElementById('epLifeTot_2_6').value = array[0].c.epLifeTot.toLocaleString();
						document.getElementById('totLifeTot_3_6').value = array[0].c.totLifeTot.toLocaleString();
					} else if (qId == 15) {
						document.getElementById('bascLifeTot_0_15').value = array[0].c.bascLifeTot.toLocaleString();
						document.getElementById('apldLifeTot_1_15').value = array[0].c.apldLifeTot.toLocaleString();
						document.getElementById('epLifeTot_2_15').value = array[0].c.epLifeTot.toLocaleString();
						document.getElementById('totLifeTot_3_15').value = array[0].c.totLifeTot.toLocaleString();
					}
					//d
					array[0].d.totMath = array[0].d.bascMath + array[0].d.apldMath + array[0].d.epMath;
					if (qId == 6)
						document.getElementById('totMath_3_6').value = array[0].d.totMath.toLocaleString();
					else if (qId == 15)
						document.getElementById('totMath_3_15').value = array[0].d.totMath.toLocaleString();
					//e
					array[0].e.totAst = array[0].e.basAst + array[0].e.appAst + array[0].e.expAst;
					array[0].e.totPhysChem = array[0].e.bascPhysChem + array[0].e.apldPhysChem + array[0].e.epPhysChem;
					array[0].e.totPhysMatl = array[0].e.bascPhysMatl + array[0].e.apldPhysMatl + array[0].e.epPhysMatl;
					array[0].e.totPhy = array[0].e.basPhy + array[0].e.appPhy + array[0].e.expPhy;
					array[0].e.totPhysNec = array[0].e.bascPhysNec + array[0].e.apldPhysNec + array[0].e.epPhysNec;
					if(qId == 6)
					{
						document.getElementById('totAst_3_6').value = array[0].e.totAst.toLocaleString();
						document.getElementById('totPhysChem_3_6').value = array[0].e.totPhysChem.toLocaleString();
						document.getElementById('totPhysMatl_3_6').value = array[0].e.totPhysMatl.toLocaleString();
						document.getElementById('totPhy_3_6').value = array[0].e.totPhy.toLocaleString();
						document.getElementById('totPhysNec_3_6').value = array[0].e.totPhysNec.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('totAst_3_15').value = array[0].e.totAst.toLocaleString();
						document.getElementById('totPhysChem_3_15').value = array[0].e.totPhysChem.toLocaleString();
						document.getElementById('totPhysMatl_3_15').value = array[0].e.totPhysMatl.toLocaleString();
						document.getElementById('totPhy_3_15').value = array[0].e.totPhy.toLocaleString();
						document.getElementById('totPhysNec_3_15').value = array[0].e.totPhysNec.toLocaleString();
					}

					array[0].e.bascPhysTot = array[0].e.basAst + array[0].e.bascPhysChem +  array[0].e.bascPhysMatl + array[0].e.basPhy + array[0].e.bascPhysNec;
					array[0].e.apldPhysTot = array[0].e.appAst + array[0].e.apldPhysChem +  array[0].e.apldPhysMatl + array[0].e.appPhy + array[0].e.apldPhysNec;
					array[0].e.epPhysTot =  array[0].e.expAst + array[0].e.epPhysChem + array[0].e.epPhysMatl + array[0].e.expPhy + array[0].e.epPhysNec;
					array[0].e.totPhysTot = array[0].e.bascPhysTot + array[0].e.apldPhysTot + array[0].e.epPhysTot;
					if(qId == 6)
					{
						document.getElementById('bascPhysTot_0_6').value = array[0].e.bascPhysTot.toLocaleString();
						document.getElementById('apldPhysTot_1_6').value = array[0].e.apldPhysTot.toLocaleString();
						document.getElementById('epPhysTot_2_6').value = array[0].e.epPhysTot.toLocaleString();
						document.getElementById('totPhysTot_3_6').value = array[0].e.totPhysTot.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('bascPhysTot_0_15').value = array[0].e.bascPhysTot.toLocaleString();
						document.getElementById('apldPhysTot_1_15').value = array[0].e.apldPhysTot.toLocaleString();
						document.getElementById('epPhysTot_2_15').value = array[0].e.epPhysTot.toLocaleString();
						document.getElementById('totPhysTot_3_15').value = array[0].e.totPhysTot.toLocaleString();
					}

					//f
					array[0].f.totPsychBio = array[0].f.bascPsychBio + array[0].f.apldPsychBio + array[0].f.epPsychBio;
					array[0].f.totPsychSoc = array[0].f.bascPsychSoc + array[0].f.apldPsychSoc + array[0].f.epPsychSoc;
					array[0].f.totPsychNec = array[0].f.bascPsychNec + array[0].f.apldPsychNec + array[0].f.epPsychNec;
					if(qId == 6)
					{
						document.getElementById('totPsychBio_3_6').value = array[0].f.totPsychBio.toLocaleString();
						document.getElementById('totPsychSoc_3_6').value = array[0].f.totPsychSoc.toLocaleString();
						document.getElementById('totPsychNec_3_6').value = array[0].f.totPsychNec.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('totPsychBio_3_15').value = array[0].f.totPsychBio.toLocaleString();
						document.getElementById('totPsychSoc_3_15').value = array[0].f.totPsychSoc.toLocaleString();
						document.getElementById('totPsychNec_3_15').value = array[0].f.totPsychNec.toLocaleString();
					}
					array[0].f.bascPsychTot = array[0].f.bascPsychBio + array[0].f.bascPsychSoc + array[0].f.bascPsychNec;
					array[0].f.apldPsychTot = array[0].f.apldPsychBio + array[0].f.apldPsychSoc + array[0].f.apldPsychNec;
					array[0].f.epPsychTot = array[0].f.epPsychBio + array[0].f.epPsychSoc + array[0].f.epPsychNec;
					array[0].f.totPsychTot = array[0].f.bascPsychTot + array[0].f.apldPsychTot + array[0].f.epPsychTot;
					if(qId == 6)
					{
						document.getElementById('bascPsychTot_0_6').value = array[0].f.bascPsychTot.toLocaleString();
						document.getElementById('apldPsychTot_1_6').value = array[0].f.apldPsychTot.toLocaleString();
						document.getElementById('epPsychTot_2_6').value = array[0].f.epPsychTot.toLocaleString();
						document.getElementById('totPsychTot_3_6').value = array[0].f.totPsychTot.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('bascPsychTot_0_15').value = array[0].f.bascPsychTot.toLocaleString();
						document.getElementById('apldPsychTot_1_15').value = array[0].f.apldPsychTot.toLocaleString();
						document.getElementById('epPsychTot_2_15').value = array[0].f.epPsychTot.toLocaleString();
						document.getElementById('totPsychTot_3_15').value = array[0].f.totPsychTot.toLocaleString();
					}
					//g
					array[0].g.totAnt = array[0].g.basAnt + array[0].g.appAnt + array[0].g.expAnt;
					array[0].g.totEco = array[0].g.basEco + array[0].g.appEco + array[0].g.expEco;
					array[0].g.totPol = array[0].g.basPol + array[0].g.appPol + array[0].g.expPol;
					array[0].g.totSocSocio = array[0].g.bascSocSocio + array[0].g.apldSocSocio + array[0].g.epSocSocio;
					array[0].g.totSocNec = array[0].g.bascSocNec + array[0].g.apldSocNec + array[0].g.epSocNec;
					if(qId == 6)
					{
						document.getElementById('totAnt_3_6').value = array[0].g.totAnt.toLocaleString();
						document.getElementById('totEco_3_6').value = array[0].g.totEco.toLocaleString();
						document.getElementById('totPol_3_6').value = array[0].g.totPol.toLocaleString();
						document.getElementById('totSocSocio_3_6').value = array[0].g.totSocSocio.toLocaleString();
						document.getElementById('totSocNec_3_6').value = array[0].g.totSocNec.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('totAnt_3_15').value = array[0].g.totAnt.toLocaleString();
						document.getElementById('totEco_3_15').value = array[0].g.totEco.toLocaleString();
						document.getElementById('totPol_3_15').value = array[0].g.totPol.toLocaleString();
						document.getElementById('totSocSocio_3_15').value = array[0].g.totSocSocio.toLocaleString();
						document.getElementById('totSocNec_3_15').value = array[0].g.totSocNec.toLocaleString();
					}
					array[0].g.bascSocTot = array[0].g.basAnt + array[0].g.basEco + array[0].g.basPol + array[0].g.bascSocSocio + array[0].g.bascSocNec;
					array[0].g.apldSocTot = array[0].g.appAnt + array[0].g.appEco + array[0].g.appPol + array[0].g.apldSocSocio + array[0].g.apldSocNec;
					array[0].g.epSocTot = array[0].g.expAnt + array[0].g.expEco + array[0].g.expPol + array[0].g.epSocSocio + array[0].g.epSocNec;
					array[0].g.totSocTot = array[0].g.bascSocTot + array[0].g.apldSocTot + array[0].g.epSocTot;
					if(qId == 6)
					{
						document.getElementById('bascSocTot_0_6').value = array[0].g.bascSocTot.toLocaleString();
						document.getElementById('apldSocTot_1_6').value = array[0].g.apldSocTot.toLocaleString();
						document.getElementById('epSocTot_2_6').value = array[0].g.epSocTot.toLocaleString();
						document.getElementById('totSocTot_3_6').value = array[0].g.totSocTot.toLocaleString();
					}
					if(qId == 15)
					{
						document.getElementById('bascSocTot_0_15').value = array[0].g.bascSocTot.toLocaleString();
						document.getElementById('apldSocTot_1_15').value = array[0].g.apldSocTot.toLocaleString();
						document.getElementById('epSocTot_2_15').value = array[0].g.epSocTot.toLocaleString();
						document.getElementById('totSocTot_3_15').value = array[0].g.totSocTot.toLocaleString();
					}
					//h
					array[0].h.totAer = array[0].h.basAer + array[0].h.appAer + array[0].h.expAer;
					array[0].h.totEngBio = array[0].h.bascEngBio + array[0].h.apldEngBio + array[0].h.epEngBio;
					array[0].h.totEngChem = array[0].h.bascEngChem + array[0].h.apldEngChem + array[0].h.epEngChem;
					array[0].h.totCiv = array[0].h.basCiv + array[0].h.appCiv + array[0].h.expCiv;
					array[0].h.totEle = array[0].h.basEle + array[0].h.appEle + array[0].h.expEle;
					array[0].h.totInd = array[0].h.basInd + array[0].h.appInd + array[0].h.expInd;
					array[0].h.totMec = array[0].h.basMec + array[0].h.appMec + array[0].h.expMec;
					array[0].h.totMet = array[0].h.basMet + array[0].h.appMet + array[0].h.expMet;
					array[0].h.totEngNec = array[0].h.bascEngNec + array[0].h.apldEngNec + array[0].h.epEngNec;
					if(qId == 6)
					{
						document.getElementById('totAer_3_6').value =  array[0].h.totAer.toLocaleString();
						document.getElementById('totEngBio_3_6').value = array[0].h.totEngBio.toLocaleString();
						document.getElementById('totEngChem_3_6').value = array[0].h.totEngChem.toLocaleString();
						document.getElementById('totCiv_3_6').value = array[0].h.totCiv.toLocaleString();
						document.getElementById('totEle_3_6').value = array[0].h.totEle.toLocaleString();
						document.getElementById('totInd_3_6').value = array[0].h.totInd.toLocaleString();
						document.getElementById('totMec_3_6').value = array[0].h.totMec.toLocaleString();
						document.getElementById('totMet_3_6').value = array[0].h.totMet.toLocaleString();
						document.getElementById('totEngNec_3_6').value = array[0].h.totEngNec.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('totAer_3_15').value =  array[0].h.totAer.toLocaleString();
						document.getElementById('totEngBio_3_15').value = array[0].h.totEngBio.toLocaleString();
						document.getElementById('totEngChem_3_15').value = array[0].h.totEngChem.toLocaleString();
						document.getElementById('totCiv_3_15').value = array[0].h.totCiv.toLocaleString();
						document.getElementById('totEle_3_15').value = array[0].h.totEle.toLocaleString();
						document.getElementById('totInd_3_15').value = array[0].h.totInd.toLocaleString();
						document.getElementById('totMec_3_15').value = array[0].h.totMec.toLocaleString();
						document.getElementById('totMet_3_15').value = array[0].h.totMet.toLocaleString();
						document.getElementById('totEngNec_3_15').value = array[0].h.totEngNec.toLocaleString();
					}

					array[0].h.bascEngTot = array[0].h.basAer + array[0].h.bascEngBio  + array[0].h.bascEngChem + array[0].h.basCiv + array[0].h.basEle + array[0].h.basInd + array[0].h.basMec + array[0].h.basMet + array[0].h.bascEngNec;
					array[0].h.apldEngTot = array[0].h.appAer + array[0].h.apldEngBio  + array[0].h.apldEngChem + array[0].h.appCiv + array[0].h.appEle + array[0].h.appInd + array[0].h.appMec + array[0].h.appMet + array[0].h.apldEngNec;
					array[0].h.epEngTot = array[0].h.expAer + array[0].h.epEngBio  + array[0].h.epEngChem + array[0].h.expCiv + array[0].h.expEle + array[0].h.expInd + array[0].h.expMec + array[0].h.expMet + array[0].h.epEngNec;
					array[0].h.totEngTot = array[0].h.bascEngTot + array[0].h.apldEngTot + array[0].h.epEngTot;
					if(qId == 6)
					{
						document.getElementById('bascEngTot_0_6').value = array[0].h.bascEngTot.toLocaleString();
						document.getElementById('apldEngTot_1_6').value = array[0].h.apldEngTot.toLocaleString();
						document.getElementById('epEngTot_2_6').value = array[0].h.epEngTot.toLocaleString();
						document.getElementById('totEngTot_3_6').value = array[0].h.totEngTot.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('bascEngTot_0_15').value = array[0].h.bascEngTot.toLocaleString();
						document.getElementById('apldEngTot_1_15').value = array[0].h.apldEngTot.toLocaleString();
						document.getElementById('epEngTot_2_15').value = array[0].h.epEngTot.toLocaleString();
						document.getElementById('totEngTot_3_15').value = array[0].h.totEngTot.toLocaleString();
					}
					//i
					array[0].i.totBus = array[0].i.basBus + array[0].i.appBus + array[0].i.expBus;
					array[0].i.totOthCom = array[0].i.bascOthCom + array[0].i.apldOthCom + array[0].i.epOthCom;
					array[0].i.totEdu = array[0].i.basEdu + array[0].i.appEdu + array[0].i.expEdu;
					array[0].i.totHum = array[0].i.basHum + array[0].i.appHum + array[0].i.expHum;
					array[0].i.totLaw = array[0].i.basLaw + array[0].i.appLaw + array[0].i.expLaw;
					array[0].i.totOthSoc = array[0].i.bascOthSoc + array[0].i.apldOthSoc + array[0].i.epOthSoc;
					array[0].i.totVis = array[0].i.basVis + array[0].i.appVis + array[0].i.expVis;
					array[0].i.totOthNec = array[0].i.bascOthNec + array[0].i.apldOthNec + array[0].i.epOthNec;
					if(qId == 6)
					{
						document.getElementById('totBus_3_6').value = array[0].i.totBus.toLocaleString();
						document.getElementById('totOthCom_3_6').value = array[0].i.totOthCom.toLocaleString();
						document.getElementById('totEdu_3_6').value = array[0].i.totEdu.toLocaleString();
						document.getElementById('totHum_3_6').value = array[0].i.totHum.toLocaleString();
						document.getElementById('totLaw_3_6').value = array[0].i.totLaw.toLocaleString();
						document.getElementById('totOthSoc_3_6').value = array[0].i.totOthSoc.toLocaleString();
						document.getElementById('totVis_3_6').value = array[0].i.totVis.toLocaleString();
						document.getElementById('totOthNec_3_6').value = array[0].i.totOthNec.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('totBus_3_15').value = array[0].i.totBus.toLocaleString();
						document.getElementById('totOthCom_3_15').value = array[0].i.totOthCom.toLocaleString();
						document.getElementById('totEdu_3_15').value = array[0].i.totEdu.toLocaleString();
						document.getElementById('totHum_3_15').value = array[0].i.totHum.toLocaleString();
						document.getElementById('totLaw_3_15').value = array[0].i.totLaw.toLocaleString();
						document.getElementById('totOthSoc_3_15').value = array[0].i.totOthSoc.toLocaleString();
						document.getElementById('totVis_3_15').value = array[0].i.totVis.toLocaleString();
						document.getElementById('totOthNec_3_15').value = array[0].i.totOthNec.toLocaleString();
					}
					array[0].i.bascOthTot = array[0].i.basBus + array[0].i.bascOthCom + array[0].i.basEdu + array[0].i.basHum  + array[0].i.basLaw + array[0].i.bascOthSoc + array[0].i.basVis + array[0].i.bascOthNec;
					array[0].i.apldOthTot = array[0].i.appBus + array[0].i.apldOthCom + array[0].i.appEdu + array[0].i.appHum  + array[0].i.appLaw + array[0].i.apldOthSoc + array[0].i.appVis + array[0].i.apldOthNec;
					array[0].i.epOthTot = array[0].i.expBus + array[0].i.epOthCom + array[0].i.expEdu + array[0].i.expHum  + array[0].i.expLaw + array[0].i.epOthSoc + array[0].i.expVis + array[0].i.epOthNec;
					array[0].i.totOthTot = array[0].i.bascOthTot + array[0].i.apldOthTot + array[0].i.epOthTot;
					if(qId == 6)
					{
						document.getElementById('bascOthTot_0_6').value = array[0].i.bascOthTot.toLocaleString();
						document.getElementById('apldOthTot_1_6').value = array[0].i.apldOthTot.toLocaleString();
						document.getElementById('epOthTot_2_6').value = array[0].i.epOthTot.toLocaleString();
						document.getElementById('totOthTot_3_6').value = array[0].i.totOthTot.toLocaleString();
					}
					else if(qId == 15)
					{
						document.getElementById('bascOthTot_0_15').value = array[0].i.bascOthTot.toLocaleString();
						document.getElementById('apldOthTot_1_15').value = array[0].i.apldOthTot.toLocaleString();
						document.getElementById('epOthTot_2_15').value = array[0].i.epOthTot.toLocaleString();
						document.getElementById('totOthTot_3_15').value = array[0].i.totOthTot.toLocaleString();
					}
					debugger;
					//j
					var basComa = isNaN(array[0].a.bascCis) ? 0: array[0].a.bascCis;
					var basTotb = isNaN(array[0].b.bascEnvrnTot)? 0 : array[0].b.bascEnvrnTot;
					var basTotc = isNaN(array[0].c.bascLifeTot)? 0 : array[0].c.bascLifeTot;
					var basMatd = isNaN(array[0].d.bascMath)? 0 : array[0].d.bascMath;
					var basTote = isNaN(array[0].e.bascPhysTot)? 0: array[0].e.bascPhysTot;
					var basTotf = isNaN(array[0].f.bascPsychTot)? 0 : array[0].f.bascPsychTot;
					var basTotg = isNaN(array[0].g.bascSocTot)? 0: array[0].g.bascSocTot;
					var basToth = isNaN(array[0].h.bascEngTot)? 0: array[0].h.bascEngTot
					var basToti = isNaN(array[0].i.bascOthTot)? 0: array[0].i.bascOthTot;
					array[0].j.basTot = basComa + basTotb + basTotc + basMatd + basTote + basTotf + basTotg + basToth + basToti;
					if(qId == 6)
						document.getElementById('basTot_0_6').value = array[0].j.basTot.toLocaleString();
					else if(qId == 15)
						document.getElementById('basTot_0_15').value = array[0].j.basTot.toLocaleString();
					var appComa = isNaN(array[0].a.apldCis) ? 0: parseInt(array[0].a.apldCis);
					var appTotb = isNaN(array[0].b.apldEnvrnTot)? 0 : parseInt(array[0].b.apldEnvrnTot);
					var appTotc = isNaN(array[0].c.apldLifeTot)? 0 : parseInt(array[0].c.apldLifeTot);
					var appMatd = isNaN(array[0].d.apldMath)? 0 : parseInt(array[0].d.apldMath);
					var appTote = isNaN(array[0].e.apldPhysTot)? 0 : parseInt(array[0].e.apldPhysTot);
					var appTotf = isNaN(array[0].f.apldPsychTot)? 0 : parseInt(array[0].f.apldPsychTot);
					var appTotg = isNaN(array[0].g.apldSocTot)? 0 : parseInt(array[0].g.apldSocTot);
					var appToth = isNaN(array[0].h.apldEngTot)? 0 : parseInt(array[0].h.apldEngTot);
					var appToti = isNaN(array[0].i.apldOthTot)? 0 : parseInt(array[0].i.apldOthTot);
					array[0].j.appTot = appComa + appTotb + appTotc + appMatd + appTote + appTotf + appTotg + appToth + appToti;
					if(qId == 6)
						document.getElementById('appTot_1_6').value = array[0].j.appTot.toLocaleString();
					if(qId == 15)
						document.getElementById('appTot_1_15').value = array[0].j.appTot.toLocaleString();

					var expComa = isNaN(array[0].a.epCis) ? 0: parseInt(array[0].a.epCis);
					var expTotb = isNaN(array[0].b.epEnvrnTot) ? 0: parseInt(array[0].b.epEnvrnTot);
					var expTotc = isNaN(array[0].c.epLifeTot)? 0 : parseInt(array[0].c.epLifeTot);
					var expMatd = isNaN(array[0].d.epMath)? 0 : parseInt(array[0].d.epMath);
					var expTote = isNaN(array[0].e.epPhysTot)? 0 : parseInt(array[0].e.epPhysTot);
					var expTotf = isNaN(array[0].f.epPsychTot)? 0 : parseInt(array[0].f.epPsychTot);
					var expTotg = isNaN(array[0].g.epSocTot)? 0 : parseInt(array[0].g.epSocTot);
					var expToth = isNaN(array[0].h.epEngTot)? 0 : parseInt(array[0].h.epEngTot);
					var expToti = isNaN(array[0].i.epOthTot)? 0 : parseInt(array[0].i.epOthTot);
					array[0].j.expTot = expComa + expTotb + expTotc + expMatd + expTote + expTotf + expTotg + expToth + expToti;
					if(qId == 6)
						document.getElementById('expTot_2_6').value = array[0].j.expTot.toLocaleString();
					else if(qId == 15)
						document.getElementById('expTot_2_15').value = array[0].j.expTot.toLocaleString();
					array[0].j.totTot = array[0].j.basTot + array[0].j.appTot + array[0].j.expTot;
					if(qId == 6)
						document.getElementById('totTot_3_6').value = array[0].j.totTot.toLocaleString();
					else if(qId == 15)
						document.getElementById('totTot_3_15').value = array[0].j.totTot.toLocaleString();
				}
				if (qId == 7)
				{
					debugger;
					array[0].totCom = array[0].basCom + array[0].appCom + array[0].expCom;
					array[0].totGeo = array[0].basGeo + array[0].appGeo + array[0].expGeo;
					array[0].totLif = array[0].basLif + array[0].appLif + array[0].expLif;
					array[0].totMat = array[0].basMat + array[0].appMat + array[0].expMat;
					array[0].totPhy = array[0].basPhy + array[0].appPhy + array[0].expPhy;
					array[0].totPsy = array[0].basPsy + array[0].appPsy + array[0].expPsy;
					array[0].totSoc = array[0].basSoc + array[0].appSoc + array[0].expSoc;
					array[0].totEng = array[0].basEng + array[0].appEng + array[0].expEng;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].expOth;

					document.getElementById('totCom_3_7').value = array[0].totCom.toLocaleString();
					document.getElementById('totGeo_3_7').value = array[0].totGeo.toLocaleString();
					document.getElementById('totLif_3_7').value = array[0].totLif.toLocaleString();
					document.getElementById('totMat_3_7').value = array[0].totMat.toLocaleString();
					document.getElementById('totPhy_3_7').value = array[0].totPhy.toLocaleString();
					document.getElementById('totPsy_3_7').value = array[0].totPsy.toLocaleString();
					document.getElementById('totSoc_3_7').value = array[0].totSoc.toLocaleString();
					document.getElementById('totEng_3_7').value = array[0].totEng.toLocaleString();
					document.getElementById('totOth_3_7').value = array[0].totOth.toLocaleString();

					array[0].basTot = array[0].basCom + array[0].basEng + array[0].basGeo + array[0].basLif + array[0].basMat + array[0].basOth + array[0].basPhy + array[0].basPsy + array[0].basSoc;
					array[0].appTot = array[0].appCom + array[0].appEng + array[0].appGeo + array[0].appLif + array[0].appMat + array[0].appOth + array[0].appPhy + array[0].appPsy + array[0].appSoc;
					array[0].expTot = array[0].expCom + array[0].expEng + array[0].expGeo + array[0].expLif + array[0].expMat + array[0].expOth + array[0].expPhy + array[0].expPsy + array[0].expSoc;
					array[0].totTot = array[0].totCom + array[0].totEng + array[0].totGeo + array[0].totLif + array[0].totMat + array[0].totOth + array[0].totPhy + array[0].totPsy + array[0].totSoc;

					document.getElementById('basTot_0_7').value = array[0].basTot.toLocaleString();
					document.getElementById('appTot_1_7').value = array[0].appTot.toLocaleString();
					document.getElementById('expTot_2_7').value = array[0].expTot.toLocaleString();
					document.getElementById('totTot_3_7').value = array[0].totTot.toLocaleString();
				}
				if (qId == 8)
				{
					//a-b
					array[0].totFed = array[0].basFed + array[0].appFed + array[0].expFed + array[0].plaFed;
					array[0].totFun = array[0].basFun + array[0].appFun + array[0].expFun + array[0].plaFun;
					//c-g
					array[0].totBus = array[0].basBus + array[0].appBus + array[0].expBus + array[0].plaBus;
					array[0].totHig = array[0].basHig + array[0].appHig + array[0].expHig + array[0].plaHig;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].expOth + array[0].plaOth;
					array[0].totSta = array[0].basSta + array[0].appSta + array[0].expSta + array[0].plaSta;
					array[0].totNon = array[0].basNon + array[0].appNon + array[0].expNon + array[0].plaNon;

					array[0].basTotNon = array[0].basBus + array[0].basHig + array[0].basOth + array[0].basSta + array[0].basNon;
					array[0].appTotNon = array[0].appBus + array[0].appHig + array[0].appOth + array[0].appSta + array[0].appNon;
					array[0].expTotNon = array[0].expBus + array[0].expHig + array[0].expOth + array[0].expSta + array[0].expNon;
					array[0].plaTotNon = array[0].plaBus + array[0].plaHig + array[0].plaOth + array[0].plaSta + array[0].plaNon;
					//Total H
					array[0].totTotNon = array[0].basTotNon + array[0].appTotNon + array[0].expTotNon + array[0].plaTotNon;
					//i
					array[0].basTot = array[0].basFed + array[0].basFun + array[0].basTotNon;
					array[0].appTot = array[0].appFed + array[0].appFun + array[0].appTotNon;
					array[0].expTot = array[0].expFed + array[0].expFun + array[0].expTotNon;
					array[0].plaTot = array[0].plaFed + array[0].plaFun + array[0].plaTotNon;
					//Total
					array[0].totTot = array[0].basTot + array[0].appTot + array[0].expTot + array[0].plaTot;

					document.getElementById('totFed_4_8').value = array[0].totFed.toLocaleString();
					document.getElementById('totFun_4_8').value = array[0].totFun.toLocaleString();
					document.getElementById('totBus_4_8').value = array[0].totBus.toLocaleString();
					document.getElementById('totHig_4_8').value = array[0].totHig.toLocaleString();
					document.getElementById('totOth_4_8').value = array[0].totOth.toLocaleString();
					document.getElementById('totSta_4_8').value = array[0].totSta.toLocaleString();
					document.getElementById('totNon_4_8').value = array[0].totNon.toLocaleString();

					document.getElementById('basTotNon_0_8').value = array[0].basTotNon.toLocaleString();
					document.getElementById('appTotNon_1_8').value = array[0].appTotNon.toLocaleString();
					document.getElementById('expTotNon_2_8').value = array[0].expTotNon.toLocaleString();
					document.getElementById('plaTotNon_3_8').value = array[0].plaTotNon.toLocaleString();
					document.getElementById('totTotNon_4_8').value = array[0].totTotNon.toLocaleString();

					document.getElementById('basTot_0_8').value = array[0].basTot.toLocaleString();
					document.getElementById('appTot_1_8').value = array[0].appTot.toLocaleString();
					document.getElementById('expTot_2_8').value = array[0].expTot.toLocaleString();
					document.getElementById('plaTot_3_8').value = array[0].plaTot.toLocaleString();
					document.getElementById('totTot_4_8').value = array[0].totTot.toLocaleString();
				}
				if (qId == 9)
				{
					//a-b
					array[0].totFed = array[0].basFed + array[0].appFed + array[0].expFed + array[0].plaFed;
					array[0].totFun = array[0].basFun + array[0].appFun + array[0].expFun + array[0].plaFun;
					//c-g
					array[0].totBus = array[0].basBus + array[0].appBus + array[0].expBus + array[0].plaBus;
					array[0].totHig = array[0].basHig + array[0].appHig + array[0].expHig + array[0].plaHig;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].expOth + array[0].plaOth;
					array[0].totSta = array[0].basSta + array[0].appSta + array[0].expSta + array[0].plaSta;
					array[0].totNon = array[0].basNon + array[0].appNon + array[0].expNon + array[0].plaNon;

					array[0].basTotNon = array[0].basBus + array[0].basHig + array[0].basOth + array[0].basSta + array[0].basNon;
					array[0].appTotNon = array[0].appBus + array[0].appHig + array[0].appOth + array[0].appSta + array[0].appNon;
					array[0].expTotNon = array[0].expBus + array[0].expHig + array[0].expOth + array[0].expSta + array[0].expNon;
					array[0].plaTotNon = array[0].plaBus + array[0].plaHig + array[0].plaOth + array[0].plaSta + array[0].plaNon;
					//Total H
					array[0].totTotNon = array[0].basTotNon + array[0].appTotNon + array[0].expTotNon + array[0].plaTotNon;
					//i
					array[0].basTot = array[0].basFed + array[0].basFun + array[0].basTotNon;
					array[0].appTot = array[0].appFed + array[0].appFun + array[0].appTotNon;
					array[0].expTot = array[0].expFed + array[0].expFun + array[0].expTotNon;
					array[0].plaTot = array[0].plaFed + array[0].plaFun + array[0].plaTotNon;
					//Total
					array[0].totTot = array[0].basTot + array[0].appTot + array[0].expTot + array[0].plaTot;

					document.getElementById('totFed_4_9').value = array[0].totFed.toLocaleString();
					document.getElementById('totFun_4_9').value = array[0].totFun.toLocaleString();
					document.getElementById('totBus_4_9').value = array[0].totBus.toLocaleString();
					document.getElementById('totHig_4_9').value = array[0].totHig.toLocaleString();
					document.getElementById('totOth_4_9').value = array[0].totOth.toLocaleString();
					document.getElementById('totSta_4_9').value = array[0].totSta.toLocaleString();
					document.getElementById('totNon_4_9').value = array[0].totNon.toLocaleString();

					document.getElementById('basTotNon_0_9').value = array[0].basTotNon.toLocaleString();
					document.getElementById('appTotNon_1_9').value = array[0].appTotNon.toLocaleString();
					document.getElementById('expTotNon_2_9').value = array[0].expTotNon.toLocaleString();
					document.getElementById('plaTotNon_3_9').value = array[0].plaTotNon.toLocaleString();
					document.getElementById('totTotNon_4_9').value = array[0].totTotNon.toLocaleString();

					document.getElementById('basTot_0_9').value = array[0].basTot.toLocaleString();
					document.getElementById('appTot_1_9').value = array[0].appTot.toLocaleString();
					document.getElementById('expTot_2_9').value = array[0].expTot.toLocaleString();
					document.getElementById('plaTot_3_9').value = array[0].plaTot.toLocaleString();
					document.getElementById('totTot_4_9').value = array[0].totTot.toLocaleString();
				}
				if (qId == 10)
				{
					array[0].totCon = array[0].conCon + array[0].plaCon;
					array[0].totGra = array[0].conGra + array[0].plaGra;

					array[0].contot = array[0].conCon + array[0].conGra;
					array[0].platot = array[0].plaCon + array[0].plaGra;

					array[0].tottot = array[0].contot + array[0].platot;

					document.getElementById('totCon_2_10').value = array[0].totCon.toLocaleString();
					document.getElementById('totGra_2_10').value = array[0].totGra.toLocaleString();
					document.getElementById('conTot_0_10').value = array[0].contot.toLocaleString();
					document.getElementById('plaTot_1_10').value = array[0].platot.toLocaleString();
					document.getElementById('totTot_2_10').value = array[0].tottot.toLocaleString();
				}
				if (qId == 11) {
					array[0].tot = array[0].con + array[0].pla;
					array[0].federalagencyid = "000007";
					array[1].tot = array[1].con + array[1].pla;
					array[1].federalagencyid = "000008";
					array[2].tot = array[2].con + array[2].pla;
					array[2].federalagencyid = "000047";
					array[3].tot = array[3].con + array[3].pla;
					array[3].federalagencyid = "000018";
					array[4].tot = array[4].con + array[4].pla;
					array[4].federalagencyid = "000019";
					array[5].tot = array[5].con + array[5].pla;
					array[5].federalagencyid = "000021";
					array[6].tot = array[6].con + array[6].pla;
					array[6].federalagencyid = "000035";
					array[7].tot = array[7].con + array[7].pla;
					array[7].federalagencyid = "000045";
					array[8].tot = array[8].con + array[8].pla;
					array[8].federalagencyid = "000046";
					array[9].tot = array[9].con + array[9].pla;
					array[9].federalagencyid = "000010";
					array[10].tot = array[10].con + array[10].pla;
					array[10].federalagencyid = "000011";
					array[11].tot = array[11].con + array[11].pla;
					array[11].federalagencyid = "000012";
					array[12].tot = array[12].con + array[12].pla;
					array[12].federalagencyid = "000013";
					array[13].tot = array[13].con + array[13].pla;
					array[13].federalagencyid = "000020";
					array[14].tot = array[14].con + array[14].pla;
					array[14].federalagencyid = "000015";
					array[15].tot = array[15].con + array[15].pla;
					array[15].federalagencyid = "000016";
					array[16].tot = array[16].con + array[16].pla;
					array[16].federalagencyid = "000017";
					array[17].tot = array[17].con + array[7].pla;
					array[17].federalagencyid = "000023";
					array[18].tot = array[18].con + array[18].pla;
					array[18].federalagencyid = "000022";
					array[19].tot = array[19].con + array[19].pla;
					array[19].federalagencyid = "000024";
					array[20].tot = array[20].con + array[20].pla;
					array[20].federalagencyid = "000048";
					array[21].tot = array[21].con + array[21].pla;
					array[21].federalagencyid = "000003";
					array[22].tot = array[22].con + array[22].pla;
					array[22].federalagencyid = "000004";
					array[23].tot = array[23].con + array[23].pla;
					array[23].federalagencyid = "000006";
					array[24].tot = array[24].con + array[24].pla;
					array[24].federalagencyid = "000025";
					array[25].tot = array[25].con + array[25].pla;
					array[25].federalagencyid = "000027";
					array[26].tot = array[26].con + array[26].pla;
					array[26].federalagencyid = "000030";
					array[27].tot = array[27].con + array[27].pla;
					array[27].federalagencyid = "000031";
					array[28].tot = array[28].con + array[28].pla;
					array[28].federalagency3d = "000033";
					array[29].tot = array[29].con + array[29].pla;
					array[29].federalagencyid = "000034";
					array[30].tot = array[30].con + array[30].pla;
					array[30].federalagencyid = "000049";
					array[31].tot = array[31].con + array[31].pla;
					array[31].federalagencyid = "000043";
					array[32].tot = array[32].con + array[32].pla;
					array[32].federalagencyid = "000037";
					array[33].tot = array[33].con + array[33].pla;
					array[33].federalagencyid = "000038";
					array[34].tot = array[34].con + array[34].pla;
					array[34].federalagencyid = "000039";
					array[35].tot = array[35].con + array[35].pla;
					array[35].federalagencyid = "000040";
					array[36].tot = array[36].con + array[36].pla;
					array[36].federalagencyid = "000036";
					array[37].tot = array[37].con + array[37].pla;
					array[37].federalagencyid = "000042";
					if (array[37].tot !== 0 && expval === "") {
						document.getElementById("span_Id").innerText = "Please enter explanation for Other department/agency, If incase not entered.";
					}	else {
						document.getElementById("span_Id").innerText = '';
					}
					var con = 0;
					var pla = 0;
					for (var i = 0; i < array.length; i++) {
						if (array[i].federalAgencyId != "000042") {
							con += array[i].con;
							pla += array[i].pla;
						}
					}
					array[37].con = con;
					array[37].pla = pla;
					array[37].tot = array[37].con + array[37].pla;
					array[37].federalagencyid = "000042";
				}
				if (qId == 12 || qId == 13)	{
					array[0].tot = array[0].fed + array[0].ffr + array[0].bus + array[0].edu + array[0].oth + array[0].sta;
					array[0].stateId = "10061";
					array[1].tot = array[1].fed + array[1].ffr + array[1].bus + array[1].edu + array[1].oth + array[1].sta;
					array[1].stateId = "11091";
					array[2].tot = array[2].fed + array[2].ffr + array[2].bus + array[2].edu + array[2].oth + array[2].sta;
					array[2].stateId = "12081";
					array[3].tot = array[3].fed + array[3].ffr + array[3].bus + array[3].edu + array[3].oth + array[3].sta;
					array[3].stateId = "13071";
					array[4].tot = array[4].fed + array[4].ffr + array[4].bus + array[4].edu + array[4].oth + array[4].sta;
					array[4].stateId = "14092";
					array[5].tot = array[5].fed + array[5].ffr + array[5].bus + array[5].edu + array[5].oth + array[5].sta;
					array[5].stateId = "15082";
					array[6].tot = array[6].fed + array[6].ffr + array[6].bus + array[6].edu + array[6].oth + array[6].sta;
					array[6].stateId = "16011";
					array[7].tot = array[7].fed + array[7].ffr + array[7].bus + array[7].edu + array[7].oth + array[7].sta;
					array[7].stateId = "17051";
					array[8].tot = array[8].fed + array[8].ffr + array[8].bus + array[8].edu + array[8].oth + array[8].sta;
					array[8].stateId = "18052";
					array[9].tot = array[9].fed + array[9].ffr + array[9].bus + array[9].edu + array[9].oth + array[9].sta;
					array[9].stateId = "19053";
					array[10].tot = array[10].fed + array[10].ffr + array[10].bus + array[10].edu + array[10].oth + array[10].sta;
					array[10].stateId = "20054";
					array[11].tot = array[11].fed + array[11].ffr + array[11].bus + array[11].edu + array[11].oth + array[11].sta;
					array[11].stateId = "21093";
					array[12].tot = array[12].fed + array[12].ffr + array[12].bus + array[12].edu + array[12].oth + array[12].sta;
					array[12].stateId = "22083";
					array[13].tot = array[13].fed + array[13].ffr + array[13].bus + array[13].edu + array[13].oth + array[13].sta;
					array[13].stateId = "23031";
					array[14].tot = array[14].fed + array[14].ffr + array[14].bus + array[14].edu + array[14].oth + array[14].sta;
					array[14].stateId = "24032";
					array[15].tot = array[15].fed + array[15].ffr + array[15].bus + array[15].edu + array[15].oth + array[15].sta;
					array[15].stateId = "25041";
					array[16].tot = array[16].fed + array[16].ffr + array[16].bus + array[16].edu + array[16].oth + array[16].sta;
					array[16].stateId = "26042";
					array[17].tot = array[17].fed + array[17].ffr + array[17].bus + array[17].edu + array[17].oth + array[17].sta;
					array[17].stateId = "27062";
					array[18].tot = array[18].fed + array[18].ffr + array[18].bus + array[18].edu + array[18].oth + array[18].sta;
					array[18].stateId = "28072";
					array[19].tot = array[19].fed + array[19].ffr + array[19].bus + array[19].edu + array[19].oth + array[19].sta;
					array[19].stateId = "29012";
					array[20].tot = array[20].fed + array[20].ffr + array[20].bus + array[20].edu + array[20].oth + array[20].sta;
					array[20].stateId = "30055";
					array[21].tot = array[21].fed + array[21].ffr + array[21].bus + array[21].edu + array[21].oth + array[21].sta;
					array[21].stateId = "31013";
					array[22].tot = array[22].fed + array[22].ffr + array[22].bus + array[22].edu + array[22].oth + array[22].sta;
					array[22].stateId = "32033";
					array[23].tot = array[23].fed + array[23].ffr + array[23].bus + array[23].edu + array[23].oth + array[23].sta;
					array[23].stateId = "33043";
					array[24].tot = array[24].fed + array[24].ffr + array[24].bus + array[24].edu + array[24].oth + array[24].sta;
					array[24].stateId = "34063";
					array[25].tot = array[25].fed + array[25].ffr + array[25].bus + array[25].edu + array[25].oth + array[25].sta;
					array[25].stateId = "35044";
					array[26].tot = array[26].fed + array[26].ffr + array[26].bus + array[26].edu + array[26].oth + array[26].sta;
					array[26].stateId = "36084";
					array[27].tot = array[27].fed + array[27].ffr + array[27].bus + array[27].edu + array[27].oth + array[27].sta;
					array[27].stateId = "37045";
					array[28].tot = array[28].fed + array[28].ffr + array[28].bus + array[28].edu + array[28].oth + array[28].sta;
					array[28].stateId = "38085";
					array[29].tot = array[29].fed + array[29].ffr + array[29].bus + array[29].edu + array[29].oth + array[29].sta;
					array[29].stateId = "39014";
					array[30].tot = array[30].fed + array[30].ffr + array[30].bus + array[30].edu + array[30].oth + array[30].sta;
					array[30].stateId = "40021";
					array[31].tot = array[31].fed + array[31].ffr + array[31].bus + array[31].edu + array[31].oth + array[31].sta;
					array[31].stateId = "41086";
					array[32].tot = array[32].fed + array[32].ffr + array[32].bus + array[32].edu + array[32].oth + array[32].sta;
					array[32].stateId = "42022";
					array[33].tot = array[33].fed + array[33].ffr + array[33].bus + array[33].edu + array[33].oth + array[33].sta;
					array[33].stateId = "43056";
					array[34].tot = array[34].fed + array[34].ffr + array[34].bus + array[34].edu + array[34].oth + array[34].sta;
					array[34].stateId = "44046";
					array[35].tot = array[35].fed + array[35].ffr + array[35].bus + array[35].edu + array[35].oth + array[35].sta;
					array[35].stateId = "45034";
					array[36].tot = array[36].fed + array[36].ffr + array[36].bus + array[36].edu + array[36].oth + array[36].sta;
					array[36].stateId = "46073";
					array[37].tot = array[37].fed + array[37].ffr + array[37].bus + array[37].edu + array[37].oth + array[37].sta;
					array[37].stateId = "47094";
					array[38].tot = array[38].fed + array[38].ffr + array[38].bus + array[38].edu + array[38].oth + array[38].sta;
					array[38].stateId = "48023";
					array[39].tot = array[39].fed + array[39].ffr + array[39].bus + array[39].edu + array[39].oth + array[39].sta;
					array[39].stateId = "49015";
					array[40].tot = array[40].fed + array[40].ffr + array[40].bus + array[40].edu + array[40].oth + array[40].sta;
					array[40].stateId = "50057";
					array[41].tot = array[41].fed + array[41].ffr + array[41].bus + array[41].edu + array[41].oth + array[41].sta;
					array[41].stateId = "51047";
					array[42].tot = array[42].fed + array[42].ffr + array[42].bus + array[42].edu + array[42].oth + array[42].sta;
					array[42].stateId = "52064";
					array[43].tot = array[43].fed + array[43].ffr + array[43].bus + array[43].edu + array[43].oth + array[43].sta;
					array[43].stateId = "53074";
					array[44].tot = array[44].fed + array[44].ffr + array[44].bus + array[44].edu + array[44].oth + array[44].sta;
					array[44].stateId = "54087";
					array[45].tot = array[45].fed + array[45].ffr + array[45].bus + array[45].edu + array[45].oth + array[45].sta;
					array[45].stateId = "55016";
					array[46].tot = array[46].fed + array[46].ffr + array[46].bus + array[46].edu + array[46].oth + array[46].sta;
					array[46].stateId = "56058";
					array[47].tot = array[47].fed + array[47].ffr + array[47].bus + array[47].edu + array[47].oth + array[47].sta;
					array[47].stateId = "57095";
					array[48].tot = array[48].fed + array[48].ffr + array[48].bus + array[48].edu + array[48].oth + array[48].sta;
					array[48].stateId = "58059";
					array[49].tot = array[49].fed + array[49].ffr + array[49].bus + array[49].edu + array[49].oth + array[49].sta;
					array[49].stateId = "59035";
					array[50].tot = array[50].fed + array[50].ffr + array[50].bus + array[50].edu + array[50].oth + array[50].sta;
					array[50].stateId = "60088";
					array[51].tot = array[51].fed + array[51].ffr + array[51].bus + array[51].edu + array[51].oth + array[51].sta;
					array[51].stateId = "70000";
					array[52].tot = array[52].fed + array[52].ffr + array[52].bus + array[52].edu + array[52].oth + array[52].sta;
					array[52].stateId = "70001";
					array[53].tot = array[53].fed + array[53].ffr + array[53].bus + array[53].edu + array[53].oth + array[53].sta;
					array[53].stateId = "70002";
					array[54].tot = array[54].fed + array[54].ffr + array[54].bus + array[54].edu + array[54].oth + array[54].sta;
					array[54].stateId = "64100";
					array[55].tot = array[55].fed + array[55].ffr + array[55].bus + array[55].edu + array[55].oth + array[55].sta;
					array[55].stateId = "70003";
					array[56].tot = array[56].fed + array[56].ffr + array[56].bus + array[56].edu + array[56].oth + array[56].sta;
					array[56].stateId = "65100";
					array[57].tot = array[57].fed + array[57].ffr + array[57].bus + array[57].edu + array[57].oth + array[57].sta;
					array[57].stateId = "62200";
					var fed = 0;
					var ffr = 0;
					var bus = 0;
					var edu = 0;
					var oth = 0;
					var sta = 0;
					for (var i = 0; i < array.length; i++)
					{
						if (array[i].stateId != 91000)
						{
							fed += array[i].fed;
							ffr += array[i].ffr;
							bus += array[i].bus;
							edu += array[i].edu;
							oth += array[i].oth;
							sta += array[i].sta;
						}
					}
					array[58].fed = fed;
					array[58].ffr = ffr;
					array[58].bus = bus;
					array[58].edu = edu;
					array[58].oth = oth;
					array[58].sta = sta;
					//TOTAL
					array[58].tot = array[58].fed + array[58].ffr + array[58].bus + array[58].edu +  array[58].oth + array[58].sta;
					array[58].stateId = "91000";
				}
				if(qId == 14)
				{
					var con = 0;
					var pla = 0;
					//International
					for (var i = 0; i < array.length; i++)
					{
						if(array[i].countryId == "International organizations")
						{
							array[i].tot = array[i].con + array[i].pla;
							con= array[i].con;
							pla= array[i].pla;
							break;
						}
					}
					for (var i = 0; i < array.length; i++)
					{
						switch (array[i].countryId)
						{
							case "International organizations":
								break;
							case "Total":
							case "Total to non-U.S. performers (a + b)":
								break;
							default:
							array[i].tot = array[i].con + array[i].pla;
							con+= array[i].con;
							pla+= array[i].pla;
							break;
						}
					}
					//Total
					for (var i = 0; i < array.length; i++)
					{
						if(array[i].countryId == "Total" || array[i].countryId == "Total to non-U.S. performers (a + b)")
						{
							array[i].con = con;
							array[i].pla = pla;
							array[i].tot = array[i].con + array[i].pla;
							break;
						}
					}
				}
				if(qId == 16 || qId == 17)
				{
					var bas = 0;
					var app = 0;
					var exp = 0;
					var pla = 0;
					for (var i = 0; i < array.length; i++)
					{
						if(i != array.length-1)
						{
								array[i].tot = array[i].bas + array[i].app + array[i].exp + array[i].pla;
								bas += array[i].bas;
								app += array[i].app;
								exp += array[i].exp;
								pla += array[i].pla;
						}
						if (qId == 16) {
							switch (i) {
								case 0:
									array[i].ffrdcId = "930042";
									break;
								case 1:
									array[i].ffrdcId = "920011";
									break;
								case 2:
									array[i].ffrdcId = "920012";
									break;
								case 3:
									array[i].ffrdcId = "930803";
									break;
								case 4:
									array[i].ffrdcId = "930013";
									break;
								case 5:
									array[i].ffrdcId = "930074";
									break;
								case 6:
									array[i].ffrdcId = "930100";
									break;
								case 7:
									array[i].ffrdcId = "930075";
									break;
								case 8:
									array[i].ffrdcId = "930038";
									break;
								case 9:
									array[i].ffrdcId = "930073";
									break;
								case 10:
									array[i].ffrdcId = "931100";
									break;
								case 11:
									array[i].ffrdcId = "920064";
									break;
								case 12:
									array[i].ffrdcId = "910002";
									break;
								case 13:
									array[i].ffrdcId = "920031";
									break;
								case 14:
									array[i].ffrdcId = "930905";
									break;
								case 15:
									array[i].ffrdcId = "930904";
									break;
								case 16:
									array[i].ffrdcId = "910005";
									break;
								case 17:
									array[i].ffrdcId = "920024";
									break;
								case 18:
									array[i].ffrdcId = "920016";
									break;
								case 19:
									array[i].ffrdcId = "910012";
									break;
								case 20:
									array[i].ffrdcId = "920010";
									break;
								case 21:
									array[i].ffrdcId = "910011";
									break;
								case 22:
									array[i].ffrdcId = "930903";
									break;
								case 23:
									array[i].ffrdcId = "920027";
									break;
								case 24:
									array[i].ffrdcId = "931110";
									break;
								case 25:
									array[i].ffrdcId = "930801";
									break;
								case 26:
									array[i].ffrdcId = "920030";
									break;
								case 27:
									array[i].ffrdcId = "930066";
									break;
								case 28:
									array[i].ffrdcId = "930047";
									break;
								case 29:
									array[i].ffrdcId = "923900";
									break;
								case 30:
									array[i].ffrdcId = "923888";
									break;
								case 31:
									array[i].ffrdcId = "930004";
									break;
								case 32:
									array[i].ffrdcId = "930885";
									break;
								case 33:
									array[i].ffrdcId = "920020";
									break;
								case 34:
									array[i].ffrdcId = "930065";
									break;
								case 35:
									array[i].ffrdcId = "910009";
									break;
								case 36:
									array[i].ffrdcId = "910010";
									break;
								case 37:
									array[i].ffrdcId = "930900";
									break;
								case 38:
									array[i].ffrdcId = "920017";
									break;
								case 39:
									array[i].ffrdcId = "920804";
									break;
								case 40:
									array[i].ffrdcId = "930041";
									break;
								case 41:
									array[i].ffrdcId = "920066";
									break;
								case 42:
									array[i].tot = array[i].bas + array[i].app + array[i].exp + array[i].pla;
									array[i].ffrdcId = "940000";
									bas = 0;
									app = 0;
									exp = 0;
									pla = 0;
									break;
							}
						}

						if(qId == 17)
						{
							if(i != array.length-1)
							{
								array[i].tot = array[i].bas + array[i].app + array[i].exp + array[i].pla;
								bas+=array[i].bas;
								app+=array[i].app;
								exp+=array[i].exp;
								pla+=array[i].pla;
							}
							switch(i)
							{
								case 0:
									array[i].uarcid="1";
									break;
								case 1:
									array[i].uarcid="16";
									break;
								case 2:
									array[i].uarcid="2";
									break;
								case 3:
									array[i].uarcid="3";
									break;
								case 4:
									array[i].uarcid="4";
									break;
								case 5:
									array[i].uarcid="5";
									break;
								case 6:
									array[i].uarcid="6";
									break;
								case 7:
									array[i].uarcid="7";
									break;
								case 8:
									array[i].uarcid="8";
									break;
								case 9:
									array[i].uarcid="9";
									break;
								case 10:
									array[i].uarcid="10";
									break;
								case 11:
									array[i].uarcid="11";
									break;
								case 12:
									array[i].uarcid="12";
									break;
								case 13:
									array[i].uarcid="13";
									break;
								case 14:
										array[i].uarcid="14";
										break;
								case 15:
									array[i].tot = array[i].bas + array[i].app + array[i].exp + array[i].pla;
									array[i].uarcid="15";
									bas=0;
									app=0;
									exp=0;
									pla=0;
									break;
							}
						}
					}
				}

				if(qId == 18)	{
					var con=0;
					var pla=0;
					var seFel = 0;
					var fac = 0;
					var oth = 0;

					for (var i = 0; i < array.length; i++)	{
						if(array[i].orgCod != "000001")	{
							array[i].tot = array[i].con + array[i].pla;
							con+=array[i].con;
							pla+= array[i].pla;
							seFel += array[i].seFel;
							fac += array[i].fac;
							oth += array[i].oth;
						}
					}
					for(var j=0;j<array.length;j++)
					{
						if(array[j].orgCod=="000001")
						{
							array[j].con=con;
							array[j].pla=pla;
							array[j].tot = con + pla;
							array[j].seFel = seFel;
							array[j].fac = fac;
							array[j].oth = oth;
							break;
						}
					}
				}
				if (qId == 19) {
					var con=0;
					var pla=0;
					for(var i=0;i<array.length;i++)	{
						if(array[i].orgCod!="000001") {
							array[i].tot = array[i].con + array[i].pla;
							con+=array[i].con;
							pla+=array[i].pla;
						}
					}
					for (var j=0;j<array.length;j++) {
						if (array[j].orgCod=="000001") {
							array[j].con=con;
							array[j].pla=pla;
							array[j].tot = con + pla;
							break;
						}
					}
				}
				if (qId == 20)	{
					array[0].rdFy1ConTot = parseInt(array[0].rdFy1BascRsch) + parseInt(array[0].rdFy1ApldRsch) + parseInt(array[0].rdFy1Exp);
					document.getElementById('rdFy1ConTot_0_20').value = array[0].rdFy1ConTot.toLocaleString();
					array[0].rdFy1ConPlantTot = parseInt(array[0].rdFy1ConTot) + parseInt(array[0].rdFy1PlantTot);
					document.getElementById('rdFy1ConPlantTot_0_20').value = array[0].rdFy1ConPlantTot.toLocaleString();

					array[0].rdFy2ConTot = parseInt(array[0].rdFy2BascRsch) + parseInt(array[0].rdFy2ApldRsch) + parseInt(array[0].rdFy2Exp);
					document.getElementById('rdFy2ConTot_1_20').value = array[0].rdFy2ConTot.toLocaleString();
					array[0].rdFy2ConPlantTot = parseInt(array[0].rdFy2ConTot) + parseInt(array[0].rdFy2PlantTot);
					document.getElementById('rdFy2ConPlantTot_1_20').value = array[0].rdFy2ConPlantTot.toLocaleString();

					array[0].chipsFy1ConTot = parseInt(array[0].chipsFy1BascRsch) + parseInt(array[0].chipsFy1ApldRsch) + parseInt(array[0].chipsFy1Exp);
					document.getElementById('chipsFy1ConTot_2_20').value = array[0].chipsFy1ConTot.toLocaleString();
					array[0].chipsFy1ConPlantTot = parseInt(array[0].chipsFy1ConTot) + parseInt(array[0].chipsFy1PlantTot);
					document.getElementById('chipsFy1ConPlantTot_2_20').value = array[0].chipsFy1ConPlantTot.toLocaleString();

					array[0].chipsFy2ConTot = parseInt(array[0].chipsFy2BascRsch) + parseInt(array[0].chipsFy2ApldRsch) + parseInt(array[0].chipsFy2Exp);
					document.getElementById('chipsFy2ConTot_3_20').value = array[0].chipsFy2ConTot.toLocaleString();
					array[0].chipsFy2ConPlantTot = parseInt(array[0].chipsFy2ConTot) + parseInt(array[0].chipsFy2PlantTot);
					document.getElementById('chipsFy2ConPlantTot_3_20').value = array[0].chipsFy2ConPlantTot.toLocaleString();

					array[0].iraFy1ConTot = parseInt(array[0].iraFy1BascRsch) + parseInt(array[0].iraFy1ApldRsch) + parseInt(array[0].iraFy1Exp);
					document.getElementById('iraFy1ConTot_4_20').value = array[0].iraFy1ConTot.toLocaleString();
					array[0].iraFy1ConPlantTot = parseInt(array[0].iraFy1ConTot) + parseInt(array[0].iraFy1PlantTot);
					document.getElementById('iraFy1ConPlantTot_4_20').value = array[0].iraFy1ConPlantTot.toLocaleString();

					array[0].iraFy2ConTot = parseInt(array[0].iraFy2BascRsch) + parseInt(array[0].iraFy2ApldRsch) + parseInt(array[0].iraFy2Exp);
					document.getElementById('iraFy2ConTot_5_20').value = array[0].iraFy2ConTot.toLocaleString();
					array[0].iraFy2ConPlantTot = parseInt(array[0].iraFy2ConTot) + parseInt(array[0].iraFy2PlantTot);
					document.getElementById('iraFy2ConPlantTot_5_20').value = array[0].iraFy2ConPlantTot.toLocaleString();

					array[0].bilFy1ConTot = parseInt(array[0].bilFy1BascRsch) + parseInt(array[0].bilFy1ApldRsch) + parseInt(array[0].bilFy1Exp);
					document.getElementById('bilFy1ConTot_6_20').value = array[0].bilFy1ConTot.toLocaleString();
					array[0].bilFy1ConPlantTot = parseInt(array[0].bilFy1ConTot) + parseInt(array[0].bilFy1PlantTot);
					document.getElementById('bilFy1ConPlantTot_6_20').value = array[0].bilFy1ConPlantTot.toLocaleString();

					array[0].bilFy2ConTot = parseInt(array[0].bilFy2BascRsch) + parseInt(array[0].bilFy2ApldRsch) + parseInt(array[0].bilFy2Exp);
					document.getElementById('bilFy2ConTot_7_20').value = array[0].bilFy2ConTot.toLocaleString();
					array[0].bilFy2ConPlantTot = parseInt(array[0].bilFy2ConTot) + parseInt(array[0].bilFy2PlantTot);
					document.getElementById('bilFy2ConPlantTot_7_20').value = array[0].bilFy2ConPlantTot.toLocaleString();
				}
			}
			if (!isStandardSurvey)
			{
				if (qId == 1)
				{
					array[0].fy1TotA = array[0].fy1Con + array[0].fy1Ope;
					array[0].fy2TotA = array[0].fy2Con + array[0].fy2Ope;

					array[0].fy1Tot = array[0].fy1TotA + array[0].fy1Pla;
					array[0].fy2Tot = array[0].fy2TotA + array[0].fy2Pla;

					document.getElementById('fy1TotA_0_1').value = array[0].fy1TotA.toLocaleString();
					document.getElementById('fy2TotA_1_1').value = array[0].fy2TotA.toLocaleString();
					document.getElementById('fy1Tot_0_1').value = array[0].fy1Tot.toLocaleString();
					document.getElementById('fy2Tot_1_1').value = array[0].fy2Tot.toLocaleString();
				}
				if (qId == 2)
				{
					var fy1Con01DOD = document.getElementById('fy1Con_0_1').value;
					var fy1Con01InNumberDOD = parseFloat(fy1Con01DOD.replaceAll(',', ''));
					var difference1 = parseFloat(fy1Con01InNumberDOD - array[0].fy1Con);
					document.getElementById('fy1Con_undefined_2').value = difference1.toLocaleString();
					var fy1Pla01DOD = document.getElementById('fy1Pla_0_1').value;
					var fy1Pla01InNumberDOD = parseFloat(fy1Pla01DOD.replaceAll(',', ''));
					var difference2 = parseFloat(fy1Pla01InNumberDOD - array[0].fy1Pla);
					document.getElementById('fy1Pla_undefined_2').value = difference2.toLocaleString();
				}
				if(qId == 3)
				{
					array[0].fy1TotA = array[0].fy1Con + array[0].fy1Ope;
					array[0].fy2TotA = array[0].fy2Con + array[0].fy2Ope;
					array[0].fy1Tot = array[0].fy1TotA + array[0].fy1Pla;
					array[0].fy2Tot = array[0].fy2TotA + array[0].fy2Pla;

					document.getElementById('fy1TotA_0_3').value = array[0].fy1TotA.toLocaleString();
					document.getElementById('fy2TotA_1_3').value = array[0].fy2TotA.toLocaleString();
					document.getElementById('fy1Tot_0_3').value = array[0].fy1Tot.toLocaleString();
					document.getElementById('fy2Tot_1_3').value = array[0].fy2Tot.toLocaleString();
				}
				if(qId == 5)
				{
					debugger;
					/* // in case of Volume : 71 or similar type by using stimulus
					array[0].fy1TotBas = array[0].fy1BasStimulus + array[0].fy1BasNonStimulus;
					array[0].fy2TotBas = array[0].fy2BasStimulus + array[0].fy2BasNonStimulus;

					array[0].fy1TotApp = array[0].fy1AppStimulus + array[0].fy1AppNonStimulus;
					array[0].fy2TotApp = array[0].fy2AppStimulus + array[0].fy2AppNonStimulus;

					array[0].fy1TotAdv = array[0].fy1AdvStimulus + array[0].fy1AdvNonStimulus;
					array[0].fy2TotAdv = array[0].fy2AdvStimulus + array[0].fy2AdvNonStimulus;

					array[0].fy1TotMaj = array[0].fy1MajStimulus + array[0].fy1MajNonStimulus;
					array[0].fy2TotMaj = array[0].fy2MajStimulus + array[0].fy2MajNonStimulus;*/
                    //Volume: 72
					array[0].fy1Tot = array[0].fy1Bas + array[0].fy1App + array[0].fy1Adv + array[0].fy1Maj + array[0].fy1Ope;
					array[0].fy2Tot = array[0].fy2Bas + array[0].fy2App + array[0].fy2Adv + array[0].fy2Maj + array[0].fy2Ope;
					document.getElementById('fy1Tot_0_5').value = array[0].fy1Tot.toLocaleString();
					document.getElementById('fy2Tot_1_5').value = array[0].fy2Tot.toLocaleString();

				}
				if(qId == 6)
				{
					debugger;
					array[0].fy1Tot =  array[0].fy1Amount + array[0].fy1Obl;
					array[0].fy2Tot =  array[0].fy2Amount + array[0].fy2Obl;

					document.getElementById('fy1Tot_0_6').value = array[0].fy1Tot.toLocaleString();
					document.getElementById('fy2Tot_1_6').value = array[0].fy2Tot.toLocaleString();

				}
				if(qId == 7 || qId == 17)
				{
					//a
					array[0].a.totCis = array[0].a.bascCis + array[0].a.apldCis + array[0].a.epCis;
					if(qId == 7)
					{
						document.getElementById('totCis_3_7').value = array[0].a.totCis.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('totCis_3_17').value = array[0].a.totCis.toLocaleString();
					}

					//b
					array[0].b.totAtm = array[0].b.basAtm + array[0].b.appAtm + array[0].b.expAtm;
					array[0].b.totGeo = array[0].b.basGeo + array[0].b.appGeo + array[0].b.expGeo;
					array[0].b.totOce = array[0].b.basOce + array[0].b.appOce + array[0].b.expOce;
					array[0].b.totEnvrnNec = array[0].b.bascEnvrnNec + array[0].b.apldEnvrnNec + array[0].b.epEnvrnNec;
					if(qId == 7)
					{
						document.getElementById('totAtm_3_7').value = array[0].b.totAtm.toLocaleString();
						document.getElementById('totGeo_3_7').value = array[0].b.totGeo.toLocaleString();
						document.getElementById('totOce_3_7').value = array[0].b.totOce.toLocaleString();
						document.getElementById('totEnvrnNec_3_7').value = array[0].b.totEnvrnNec.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('totAtm_3_17').value = array[0].b.totAtm.toLocaleString();
						document.getElementById('totGeo_3_17').value = array[0].b.totGeo.toLocaleString();
						document.getElementById('totOce_3_17').value = array[0].b.totOce.toLocaleString();
						document.getElementById('totEnvrnNec_3_17').value = array[0].b.totEnvrnNec.toLocaleString();
					}

    				array[0].b.bascEnvrnTot = array[0].b.basAtm + array[0].b.basGeo + array[0].b.basOce + array[0].b.bascEnvrnNec;
					array[0].b.apldEnvrnTot = array[0].b.appAtm + array[0].b.appGeo + array[0].b.appOce + array[0].b.apldEnvrnNec;
					array[0].b.epEnvrnTot = array[0].b.expAtm + array[0].b.expGeo + array[0].b.expOce + array[0].b.epEnvrnNec;
					array[0].b.totEnvrnTot = array[0].b.bascEnvrnTot + array[0].b.apldEnvrnTot + array[0].b.epEnvrnTot;

					if(qId == 7)
					{
						document.getElementById('bascEnvrnTot_0_7').value = array[0].b.bascEnvrnTot.toLocaleString();
						document.getElementById('apldEnvrnTot_1_7').value = array[0].b.apldEnvrnTot.toLocaleString();
						document.getElementById('epEnvrnTot_2_7').value = array[0].b.epEnvrnTot.toLocaleString();
						document.getElementById('totEnvrnTot_3_7').value = array[0].b.totEnvrnTot.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('bascEnvrnTot_0_17').value = array[0].b.bascEnvrnTot.toLocaleString();
						document.getElementById('apldEnvrnTot_1_17').value = array[0].b.apldEnvrnTot.toLocaleString();
						document.getElementById('epEnvrnTot_2_17').value = array[0].b.epEnvrnTot.toLocaleString();
						document.getElementById('totEnvrnTot_3_17').value = array[0].b.totEnvrnTot.toLocaleString();
					}

					//c
					array[0].c.totAgr = array[0].c.basAgr + array[0].c.appAgr + array[0].c.expAgr;
					array[0].c.totLifeBio = array[0].c.bascLifeBio + array[0].c.apldLifeBio + array[0].c.epLifeBio;
					array[0].c.totHea = array[0].c.basHea + array[0].c.appHea + array[0].c.expHea;
					array[0].c.totNat = array[0].c.basNat + array[0].c.appNat + array[0].c.expNat;
					array[0].c.totLifeNec = array[0].c.bascLifeNec + array[0].c.apldLifeNec + array[0].c.epLifeNec;

					if(qId == 7)
					{
						document.getElementById('totAgr_3_7').value = array[0].c.totAgr.toLocaleString();
						document.getElementById('totLifeBio_3_7').value = array[0].c.totLifeBio.toLocaleString();
						document.getElementById('totHea_3_7').value = array[0].c.totHea.toLocaleString();
						document.getElementById('totNat_3_7').value = array[0].c.totNat.toLocaleString();
						document.getElementById('totLifeNec_3_7').value = array[0].c.totLifeNec.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('totAgr_3_17').value = array[0].c.totAgr.toLocaleString();
						document.getElementById('totLifeBio_3_17').value = array[0].c.totLifeBio.toLocaleString();
						document.getElementById('totHea_3_17').value = array[0].c.totHea.toLocaleString();
						document.getElementById('totNat_3_17').value = array[0].c.totNat.toLocaleString();
						document.getElementById('totLifeNec_3_17').value = array[0].c.totLifeNec.toLocaleString();
					}

					array[0].c.bascLifeTot = array[0].c.basAgr + array[0].c.bascLifeBio + array[0].c.basHea + array[0].c.basNat + array[0].c.bascLifeNec;
					array[0].c.apldLifeTot = array[0].c.appAgr + array[0].c.apldLifeBio + array[0].c.appHea + array[0].c.appNat + array[0].c.apldLifeNec;
					array[0].c.epLifeTot = array[0].c.expAgr + array[0].c.epLifeBio + array[0].c.expHea + array[0].c.expNat + array[0].c.epLifeNec;
					array[0].c.totLifeTot = array[0].c.bascLifeTot + array[0].c.apldLifeTot + array[0].c.epLifeTot;

					if(qId == 7)
					{
						document.getElementById('bascLifeTot_0_7').value = array[0].c.bascLifeTot.toLocaleString();
						document.getElementById('apldLifeTot_1_7').value = array[0].c.apldLifeTot.toLocaleString();
						document.getElementById('epLifeTot_2_7').value = array[0].c.epLifeTot.toLocaleString();
						document.getElementById('totLifeTot_3_7').value = array[0].c.totLifeTot.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('bascLifeTot_0_17').value = array[0].c.bascLifeTot.toLocaleString();
						document.getElementById('apldLifeTot_1_17').value = array[0].c.apldLifeTot.toLocaleString();
						document.getElementById('epLifeTot_2_17').value = array[0].c.epLifeTot.toLocaleString();
						document.getElementById('totLifeTot_3_17').value = array[0].c.totLifeTot.toLocaleString();
					}
					//d
					array[0].d.totMath = array[0].d.bascMath + array[0].d.apldMath + array[0].d.epMath;
					if(qId == 7)
						document.getElementById('totMath_3_7').value = array[0].d.totMath.toLocaleString();
					else if(qId == 17)
						document.getElementById('totMath_3_17').value = array[0].d.totMath.toLocaleString();

					//e
					array[0].e.totAst = array[0].e.basAst + array[0].e.appAst + array[0].e.expAst;
					array[0].e.totPhysChem = array[0].e.bascPhysChem + array[0].e.apldPhysChem + array[0].e.epPhysChem;
					array[0].e.totPhysMatl = array[0].e.bascPhysMatl + array[0].e.apldPhysMatl + array[0].e.epPhysMatl;
					array[0].e.totPhy = array[0].e.basPhy + array[0].e.appPhy + array[0].e.expPhy;
					array[0].e.totPhysNec = array[0].e.bascPhysNec + array[0].e.apldPhysNec + array[0].e.epPhysNec;

					if(qId == 7)
					{
						document.getElementById('totAst_3_7').value = array[0].e.totAst.toLocaleString();
						document.getElementById('totPhysChem_3_7').value = array[0].e.totPhysChem.toLocaleString();
						document.getElementById('totPhysMatl_3_7').value = array[0].e.totPhysMatl.toLocaleString();
						document.getElementById('totPhy_3_7').value = array[0].e.totPhy.toLocaleString();
						document.getElementById('totPhysNec_3_7').value = array[0].e.totPhysNec.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('totAst_3_17').value = array[0].e.totAst.toLocaleString();
						document.getElementById('totPhysChem_3_17').value = array[0].e.totPhysChem.toLocaleString();
						document.getElementById('totPhysMatl_3_17').value = array[0].e.totPhysMatl.toLocaleString();
						document.getElementById('totPhy_3_17').value = array[0].e.totPhy.toLocaleString();
						document.getElementById('totPhysNec_3_17').value = array[0].e.totPhysNec.toLocaleString();
					}
					array[0].e.bascPhysTot = array[0].e.basAst + array[0].e.bascPhysChem +  array[0].e.bascPhysMatl + array[0].e.basPhy + array[0].e.bascPhysNec;
					array[0].e.apldPhysTot = array[0].e.appAst + array[0].e.apldPhysChem +  array[0].e.apldPhysMatl + array[0].e.appPhy + array[0].e.apldPhysNec;
					array[0].e.epPhysTot =  array[0].e.expAst + array[0].e.epPhysChem + array[0].e.epPhysMatl + array[0].e.expPhy + array[0].e.epPhysNec;
					array[0].e.totPhysTot = array[0].e.bascPhysTot + array[0].e.apldPhysTot + array[0].e.epPhysTot;
					if(qId == 7)
					{
						document.getElementById('bascPhysTot_0_7').value = array[0].e.bascPhysTot.toLocaleString();
						document.getElementById('apldPhysTot_1_7').value = array[0].e.apldPhysTot.toLocaleString();
						document.getElementById('epPhysTot_2_7').value = array[0].e.epPhysTot.toLocaleString();
						document.getElementById('totPhysTot_3_7').value = array[0].e.totPhysTot.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('bascPhysTot_0_17').value = array[0].e.bascPhysTot.toLocaleString();
						document.getElementById('apldPhysTot_1_17').value = array[0].e.apldPhysTot.toLocaleString();
						document.getElementById('epPhysTot_2_17').value = array[0].e.epPhysTot.toLocaleString();
						document.getElementById('totPhysTot_3_17').value = array[0].e.totPhysTot.toLocaleString();
					}
					//f
					array[0].f.totPsychBio = array[0].f.bascPsychBio + array[0].f.apldPsychBio + array[0].f.epPsychBio;
					array[0].f.totPsychSoc = array[0].f.bascPsychSoc + array[0].f.apldPsychSoc + array[0].f.epPsychSoc;
					array[0].f.totPsychNec = array[0].f.bascPsychNec + array[0].f.apldPsychNec + array[0].f.epPsychNec;
					if(qId == 7)
					{
						document.getElementById('totPsychBio_3_7').value = array[0].f.totPsychBio.toLocaleString();
						document.getElementById('totPsychSoc_3_7').value = array[0].f.totPsychSoc.toLocaleString();
						document.getElementById('totPsychNec_3_7').value = array[0].f.totPsychNec.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('totPsychBio_3_17').value = array[0].f.totPsychBio.toLocaleString();
						document.getElementById('totPsychSoc_3_17').value = array[0].f.totPsychSoc.toLocaleString();
						document.getElementById('totPsychNec_3_17').value = array[0].f.totPsychNec.toLocaleString();
					}

					array[0].f.bascPsychTot = array[0].f.bascPsychBio + array[0].f.bascPsychSoc + array[0].f.bascPsychNec;
					array[0].f.apldPsychTot = array[0].f.apldPsychBio + array[0].f.apldPsychSoc + array[0].f.apldPsychNec;
					array[0].f.epPsychTot = array[0].f.epPsychBio + array[0].f.epPsychSoc + array[0].f.epPsychNec;
					array[0].f.totPsychTot = array[0].f.bascPsychTot + array[0].f.apldPsychTot + array[0].f.epPsychTot;
					if(qId == 7)
					{
						document.getElementById('bascPsychTot_0_7').value = array[0].f.bascPsychTot.toLocaleString();
						document.getElementById('apldPsychTot_1_7').value = array[0].f.apldPsychTot.toLocaleString();
						document.getElementById('epPsychTot_2_7').value = array[0].f.epPsychTot.toLocaleString();
						document.getElementById('totPsychTot_3_7').value = array[0].f.totPsychTot.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('bascPsychTot_0_17').value = array[0].f.bascPsychTot.toLocaleString();
						document.getElementById('apldPsychTot_1_17').value = array[0].f.apldPsychTot.toLocaleString();
						document.getElementById('epPsychTot_2_17').value = array[0].f.epPsychTot.toLocaleString();
						document.getElementById('totPsychTot_3_17').value = array[0].f.totPsychTot.toLocaleString();
					}
					//g
					array[0].g.totAnt = array[0].g.basAnt + array[0].g.appAnt + array[0].g.expAnt;
					array[0].g.totEco = array[0].g.basEco + array[0].g.appEco + array[0].g.expEco;
					array[0].g.totPol = array[0].g.basPol + array[0].g.appPol + array[0].g.expPol;
					array[0].g.totSocSocio = array[0].g.bascSocSocio + array[0].g.apldSocSocio + array[0].g.epSocSocio;
					if(qId == 7)
					{
						document.getElementById('totAnt_3_7').value = array[0].g.totAnt.toLocaleString();
						document.getElementById('totEco_3_7').value = array[0].g.totEco.toLocaleString();
						document.getElementById('totPol_3_7').value = array[0].g.totPol.toLocaleString();
						document.getElementById('totSocSocio_3_7').value = array[0].g.totSocSocio.toLocaleString();
						document.getElementById('totSocNec_3_7').value = array[0].g.totSocNec.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('totAnt_3_17').value = array[0].g.totAnt.toLocaleString();
						document.getElementById('totEco_3_17').value = array[0].g.totEco.toLocaleString();
						document.getElementById('totPol_3_17').value = array[0].g.totPol.toLocaleString();
						document.getElementById('totSocSocio_3_17').value = array[0].g.totSocSocio.toLocaleString();
						document.getElementById('totSocNec_3_17').value = array[0].g.totSocNec.toLocaleString();
					}
					array[0].g.totSocNec = array[0].g.bascSocNec + array[0].g.apldSocNec + array[0].g.epSocNec;
					array[0].g.bascSocTot = array[0].g.basAnt + array[0].g.basEco + array[0].g.basPol + array[0].g.bascSocSocio + array[0].g.bascSocNec;
					array[0].g.apldSocTot = array[0].g.appAnt + array[0].g.appEco + array[0].g.appPol + array[0].g.apldSocSocio + array[0].g.apldSocNec;
					array[0].g.epSocTot = array[0].g.expAnt + array[0].g.expEco + array[0].g.expPol + array[0].g.epSocSocio + array[0].g.epSocNec;
					array[0].g.totSocTot = array[0].g.bascSocTot + array[0].g.apldSocTot + array[0].g.epSocTot;
					if(qId == 7)
					{
						document.getElementById('bascSocTot_0_7').value = array[0].g.bascSocTot.toLocaleString();
						document.getElementById('apldSocTot_1_7').value = array[0].g.apldSocTot.toLocaleString();
						document.getElementById('epSocTot_2_7').value = array[0].g.epSocTot.toLocaleString();
						document.getElementById('totSocTot_3_7').value = array[0].g.totSocTot.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('bascSocTot_0_17').value = array[0].g.bascSocTot.toLocaleString();
						document.getElementById('apldSocTot_1_17').value = array[0].g.apldSocTot.toLocaleString();
						document.getElementById('epSocTot_2_17').value = array[0].g.epSocTot.toLocaleString();
						document.getElementById('totSocTot_3_17').value = array[0].g.totSocTot.toLocaleString();
					}
					//h
					array[0].h.totAer = array[0].h.basAer + array[0].h.appAer + array[0].h.expAer;
					array[0].h.totEngBio = array[0].h.bascEngBio + array[0].h.apldEngBio + array[0].h.epEngBio;
					array[0].h.totEngChem = array[0].h.bascEngChem + array[0].h.apldEngChem + array[0].h.epEngChem;
					array[0].h.totCiv = array[0].h.basCiv + array[0].h.appCiv + array[0].h.expCiv;
					array[0].h.totEle = array[0].h.basEle + array[0].h.appEle + array[0].h.expEle;
					array[0].h.totInd = array[0].h.basInd + array[0].h.appInd + array[0].h.expInd;
					array[0].h.totMec = array[0].h.basMec + array[0].h.appMec + array[0].h.expMec;
					array[0].h.totMet = array[0].h.basMet + array[0].h.appMet + array[0].h.expMet;
					array[0].h.totEngNec = array[0].h.bascEngNec + array[0].h.apldEngNec + array[0].h.epEngNec;
					if(qId == 7)
					{
						document.getElementById('totAer_3_7').value =  array[0].h.totAer.toLocaleString();
						document.getElementById('totEngBio_3_7').value = array[0].h.totEngBio.toLocaleString();
						document.getElementById('totEngChem_3_7').value = array[0].h.totEngChem.toLocaleString();
						document.getElementById('totCiv_3_7').value = array[0].h.totCiv.toLocaleString();
						document.getElementById('totEle_3_7').value = array[0].h.totEle.toLocaleString();
						document.getElementById('totInd_3_7').value = array[0].h.totInd.toLocaleString();
						document.getElementById('totMec_3_7').value = array[0].h.totMec.toLocaleString();
						document.getElementById('totMet_3_7').value = array[0].h.totMet.toLocaleString();
						document.getElementById('totEngNec_3_7').value = array[0].h.totEngNec.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('totAer_3_17').value =  array[0].h.totAer.toLocaleString();
						document.getElementById('totEngBio_3_17').value = array[0].h.totEngBio.toLocaleString();
						document.getElementById('totEngChem_3_17').value = array[0].h.totEngChem.toLocaleString();
						document.getElementById('totCiv_3_17').value = array[0].h.totCiv.toLocaleString();
						document.getElementById('totEle_3_17').value = array[0].h.totEle.toLocaleString();
						document.getElementById('totInd_3_17').value = array[0].h.totInd.toLocaleString();
						document.getElementById('totMec_3_17').value = array[0].h.totMec.toLocaleString();
						document.getElementById('totMet_3_17').value = array[0].h.totMet.toLocaleString();
						document.getElementById('totEngNec_3_17').value = array[0].h.totEngNec.toLocaleString();
					}
					array[0].h.bascEngTot = array[0].h.basAer + array[0].h.bascEngBio  + array[0].h.bascEngChem + array[0].h.basCiv + array[0].h.basEle + array[0].h.basInd + array[0].h.basMec + array[0].h.basMet + array[0].h.bascEngNec;
					array[0].h.apldEngTot = array[0].h.appAer + array[0].h.apldEngBio  + array[0].h.apldEngChem + array[0].h.appCiv + array[0].h.appEle + array[0].h.appInd + array[0].h.appMec + array[0].h.appMet + array[0].h.apldEngNec;
					array[0].h.epEngTot = array[0].h.expAer + array[0].h.epEngBio  + array[0].h.epEngChem + array[0].h.expCiv + array[0].h.expEle + array[0].h.expInd + array[0].h.expMec + array[0].h.expMet + array[0].h.epEngNec;
					array[0].h.totEngTot = array[0].h.bascEngTot + array[0].h.apldEngTot + array[0].h.epEngTot;
					if(qId == 7)
					{
						document.getElementById('bascEngTot_0_7').value = array[0].h.bascEngTot.toLocaleString();
						document.getElementById('apldEngTot_1_7').value = array[0].h.apldEngTot.toLocaleString();
						document.getElementById('epEngTot_2_7').value = array[0].h.epEngTot.toLocaleString();
						document.getElementById('totEngTot_3_7').value = array[0].h.totEngTot.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('bascEngTot_0_17').value = array[0].h.bascEngTot.toLocaleString();
						document.getElementById('apldEngTot_1_17').value = array[0].h.apldEngTot.toLocaleString();
						document.getElementById('epEngTot_2_17').value = array[0].h.epEngTot.toLocaleString();
						document.getElementById('totEngTot_3_17').value = array[0].h.totEngTot.toLocaleString();
					}
					//i
					array[0].i.totBus = array[0].i.basBus + array[0].i.appBus + array[0].i.expBus;
					array[0].i.totOthCom = array[0].i.bascOthCom + array[0].i.apldOthCom + array[0].i.epOthCom;
					array[0].i.totEdu = array[0].i.basEdu + array[0].i.appEdu + array[0].i.expEdu;
					array[0].i.totHum = array[0].i.basHum + array[0].i.appHum + array[0].i.expHum;
					array[0].i.totLaw = array[0].i.basLaw + array[0].i.appLaw + array[0].i.expLaw;
					array[0].i.totOthSoc = array[0].i.bascOthSoc + array[0].i.apldOthSoc + array[0].i.epOthSoc;
					array[0].i.totVis = array[0].i.basVis + array[0].i.appVis + array[0].i.expVis;
					array[0].i.totOthNec = array[0].i.bascOthNec + array[0].i.apldOthNec + array[0].i.epOthNec;
					if(qId == 7)
					{
						document.getElementById('totBus_3_7').value = array[0].i.totBus.toLocaleString();
						document.getElementById('totOthCom_3_7').value = array[0].i.totOthCom.toLocaleString();
						document.getElementById('totEdu_3_7').value = array[0].i.totEdu.toLocaleString();
						document.getElementById('totHum_3_7').value = array[0].i.totHum.toLocaleString();
						document.getElementById('totLaw_3_7').value = array[0].i.totLaw.toLocaleString();
						document.getElementById('totOthSoc_3_7').value = array[0].i.totOthSoc.toLocaleString();
						document.getElementById('totVis_3_7').value = array[0].i.totVis.toLocaleString();
						document.getElementById('totOthNec_3_7').value = array[0].i.totOthNec.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('totBus_3_17').value = array[0].i.totBus.toLocaleString();
						document.getElementById('totOthCom_3_17').value = array[0].i.totOthCom.toLocaleString();
						document.getElementById('totEdu_3_17').value = array[0].i.totEdu.toLocaleString();
						document.getElementById('totHum_3_17').value = array[0].i.totHum.toLocaleString();
						document.getElementById('totLaw_3_17').value = array[0].i.totLaw.toLocaleString();
						document.getElementById('totOthSoc_3_17').value = array[0].i.totOthSoc.toLocaleString();
						document.getElementById('totVis_3_17').value = array[0].i.totVis.toLocaleString();
						document.getElementById('totOthNec_3_17').value = array[0].i.totOthNec.toLocaleString();
					}
					array[0].i.bascOthTot = array[0].i.basBus + array[0].i.bascOthCom + array[0].i.basEdu + array[0].i.basHum  + array[0].i.basLaw + array[0].i.bascOthSoc + array[0].i.basVis + array[0].i.bascOthNec;
					array[0].i.apldOthTot = array[0].i.appBus + array[0].i.apldOthCom + array[0].i.appEdu + array[0].i.appHum  + array[0].i.appLaw + array[0].i.apldOthSoc + array[0].i.appVis + array[0].i.apldOthNec;
					array[0].i.epOthTot = array[0].i.expBus + array[0].i.epOthCom + array[0].i.expEdu + array[0].i.expHum  + array[0].i.expLaw + array[0].i.epOthSoc + array[0].i.expVis + array[0].i.epOthNec;
					array[0].i.totOthTot = array[0].i.bascOthTot + array[0].i.apldOthTot + array[0].i.epOthTot;
					if(qId == 7)
					{
						document.getElementById('bascOthTot_0_7').value = array[0].i.bascOthTot.toLocaleString();
						document.getElementById('apldOthTot_1_7').value = array[0].i.apldOthTot.toLocaleString();
						document.getElementById('epOthTot_2_7').value = array[0].i.epOthTot.toLocaleString();
						document.getElementById('totOthTot_3_7').value = array[0].i.totOthTot.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('bascOthTot_0_17').value = array[0].i.bascOthTot.toLocaleString();
						document.getElementById('apldOthTot_1_17').value = array[0].i.apldOthTot.toLocaleString();
						document.getElementById('epOthTot_2_17').value = array[0].i.epOthTot.toLocaleString();
						document.getElementById('totOthTot_3_17').value = array[0].i.totOthTot.toLocaleString();
					}
					//j
					debugger;
					var basComa = isNaN(array[0].a.bascCis) ? 0: array[0].a.bascCis;
					var basTotb = isNaN(array[0].b.bascEnvrnTot)? 0 : array[0].b.bascEnvrnTot;
					var basTotc = isNaN(array[0].c.bascLifeTot)? 0 : array[0].c.bascLifeTot;
					var basMatd = isNaN(array[0].d.bascMath)? 0 : array[0].d.bascMath;
					var basTote = isNaN(array[0].e.bascPhysTot)? 0: array[0].e.bascPhysTot;
					var basTotf = isNaN(array[0].f.bascPsychTot)? 0 : array[0].f.bascPsychTot;
					var basTotg = isNaN(array[0].g.bascSocTot)? 0: array[0].g.bascSocTot;
					var basToth = isNaN(array[0].h.bascEngTot)? 0: array[0].h.bascEngTot;
					var basToti = isNaN(array[0].i.bascOthTot)? 0: array[0].i.bascOthTot;
					array[0].j.basTot = basComa + basTotb + basTotc + basMatd + basTote + basTotf + basTotg + basToth + basToti;
					if(qId == 7)
					{
						document.getElementById('basTot_0_7').value = array[0].j.basTot.toLocaleString();
					}
					else if(qId == 17)
					{
						document.getElementById('basTot_0_17').value = array[0].j.basTot.toLocaleString();
					}
					var appComa = isNaN(array[0].a.apldCis) ? 0: parseInt(array[0].a.apldCis);
					var appTotb = isNaN(array[0].b.apldEnvrnTot)? 0 : parseInt(array[0].b.apldEnvrnTot);
					var appTotc = isNaN(array[0].c.apldLifeTot)? 0 : parseInt(array[0].c.apldLifeTot);
					var appMatd = isNaN(array[0].d.apldMath)? 0 : parseInt(array[0].d.apldMath);
					var appTote = isNaN(array[0].e.apldPhysTot)? 0 : parseInt(array[0].e.apldPhysTot);
					var appTotf = isNaN(array[0].f.apldPsychTot)? 0 : parseInt(array[0].f.apldPsychTot);
					var appTotg = isNaN(array[0].g.apldSocTot)? 0 : parseInt(array[0].g.apldSocTot);
					var appToth = isNaN(array[0].h.apldEngTot)? 0 : parseInt(array[0].h.apldEngTot);
					var appToti = isNaN(array[0].i.apldOthTot)? 0 : parseInt(array[0].i.apldOthTot);
					array[0].j.appTot = appComa + appTotb + appTotc + appMatd + appTote + appTotf + appTotg + appToth + appToti;
					if(qId == 7)
						document.getElementById('appTot_1_7').value = array[0].j.appTot.toLocaleString();
					else if(qId == 17)
						document.getElementById('appTot_1_17').value = array[0].j.appTot.toLocaleString();

					var expComa = isNaN(array[0].a.epCis) ? 0: parseInt(array[0].a.epCis);
					var expTotb = isNaN(array[0].b.epEnvrnTot) ? 0: parseInt(array[0].b.epEnvrnTot);
					var expTotc = isNaN(array[0].c.epLifeTot)? 0 : parseInt(array[0].c.epLifeTot);
					var expMat = isNaN(array[0].d.epMath)? 0 : parseInt(array[0].d.epMath);
					var expTote =  isNaN(array[0].e.epPhysTot)? 0 : parseInt(array[0].e.epPhysTot);
					var expTotf =  isNaN(array[0].f.epPsychTot)? 0 : parseInt(array[0].f.epPsychTot);
					var expTotg = isNaN(array[0].g.epSocTot)? 0 : parseInt(array[0].g.epSocTot);
					var expToth = isNaN(array[0].h.epEngTot)? 0 : parseInt(array[0].h.epEngTot);
					var expToti = isNaN(array[0].i.epOthTot)? 0 : parseInt(array[0].i.epOthTot);
					array[0].j.expTot = expComa + expTotb + expTotc + expMat+ expTote + expTotf + expTotg + expToth + expToti;
					if(qId == 7)
						document.getElementById('expTot_2_7').value = array[0].j.expTot.toLocaleString();
					else if(qId == 17)
						document.getElementById('expTot_2_17').value = array[0].j.expTot.toLocaleString();

					array[0].j.totTot = array[0].j.basTot + array[0].j.appTot + array[0].j.expTot;
					if(qId == 7)
						document.getElementById('totTot_3_7').value = array[0].j.totTot.toLocaleString();
					else if(qId == 17)
						document.getElementById('totTot_3_17').value = array[0].j.totTot.toLocaleString();
				}
				if(qId == 8)
				{
					array[0].totCom = array[0].basCom + array[0].appCom + array[0].expCom;
					array[0].totGeo = array[0].basGeo + array[0].appGeo + array[0].expGeo;
					array[0].totLif = array[0].basLif + array[0].appLif + array[0].expLif;
					array[0].totMat = array[0].basMat + array[0].appMat + array[0].expMat;
					array[0].totPhy = array[0].basPhy + array[0].appPhy + array[0].expPhy;
					array[0].totPsy = array[0].basPsy + array[0].appPsy + array[0].expPsy;
					array[0].totSoc = array[0].basSoc + array[0].appSoc + array[0].expSoc;
					array[0].totEng = array[0].basEng + array[0].appEng + array[0].expEng;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].expOth;

					document.getElementById('totCom_3_8').value = array[0].totCom;
					document.getElementById('totGeo_3_8').value = array[0].totGeo;
					document.getElementById('totLif_3_8').value = array[0].totLif;
					document.getElementById('totMat_3_8').value = array[0].totMat;
					document.getElementById('totPhy_3_8').value = array[0].totPhy;
					document.getElementById('totPsy_3_8').value = array[0].totPsy;
					document.getElementById('totSoc_3_8').value = array[0].totSoc;
					document.getElementById('totEng_3_8').value = array[0].totEng;
					document.getElementById('totOth_3_8').value = array[0].totOth;


					array[0].basTot = array[0].basCom + array[0].basEng + array[0].basGeo + array[0].basLif + array[0].basMat + array[0].basOth + array[0].basPhy + array[0].basPsy + array[0].basSoc;
					array[0].appTot = array[0].appCom + array[0].appEng + array[0].appGeo + array[0].appLif + array[0].appMat + array[0].appOth + array[0].appPhy + array[0].appPsy + array[0].appSoc;
					array[0].expTot = array[0].expCom + array[0].expEng + array[0].expGeo + array[0].expLif + array[0].expMat + array[0].expOth + array[0].expPhy + array[0].expPsy + array[0].expSoc;
					array[0].totTot = array[0].totCom + array[0].totEng + array[0].totGeo + array[0].totLif + array[0].totMat + array[0].totOth + array[0].totPhy + array[0].totPsy + array[0].totSoc;

					document.getElementById('basTot_0_8').value = array[0].basTot.toLocaleString();
					document.getElementById('appTot_1_8').value = array[0].appTot.toLocaleString();
					document.getElementById('expTot_2_8').value = array[0].expTot.toLocaleString();
					document.getElementById('totTot_3_8').value = array[0].totTot.toLocaleString();

				}
				if(qId == 9)
				{
					array[0].totFed = array[0].basFed + array[0].appFed + array[0].advFed + array[0].majFed + array[0].opeFed + array[0].plaFed;
					array[0].totFun = array[0].basFun + array[0].appFun + array[0].advFun + array[0].majFun + array[0].opeFun + array[0].plaFun;
					array[0].totBus = array[0].basBus + array[0].appBus + array[0].advBus + array[0].majBus + array[0].opeBus + array[0].plaBus;
					array[0].totHig = array[0].basHig + array[0].appHig + array[0].advHig + array[0].majHig + array[0].opeHig + array[0].plaHig;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].advOth + array[0].majOth + array[0].opeOth + array[0].plaOth;
					array[0].totSta = array[0].basSta + array[0].appSta + array[0].advSta + array[0].majSta + array[0].opeSta + array[0].plaSta;
					array[0].totNon = array[0].basNon + array[0].appNon + array[0].advNon + array[0].majNon + array[0].opeNon + array[0].plaNon;

					document.getElementById('totFed_6_9').value = array[0].totFed;
					document.getElementById('totFun_6_9').value = array[0].totFun;
					document.getElementById('totBus_6_9').value = array[0].totBus;
					document.getElementById('totHig_6_9').value = array[0].totHig;
					document.getElementById('totOth_6_9').value = array[0].totOth;
					document.getElementById('totSta_6_9').value = array[0].totSta;
					document.getElementById('totNon_6_9').value = array[0].totNon;

					array[0].basTotH = array[0].basBus + array[0].basHig + array[0].basOth + array[0].basSta + array[0].basNon;
					array[0].appTotH = array[0].appBus + array[0].appHig + array[0].appOth + array[0].appSta + array[0].appNon;
					array[0].advTotH = array[0].advBus + array[0].advHig + array[0].advOth + array[0].advSta + array[0].advNon;
					array[0].majTotH = array[0].majBus + array[0].majHig + array[0].majOth + array[0].majSta + array[0].majNon;
					array[0].opeTotH = array[0].opeBus + array[0].opeHig + array[0].opeOth + array[0].opeSta + array[0].opeNon;
					array[0].plaTotH = array[0].plaBus + array[0].plaHig + array[0].plaOth + array[0].plaSta + array[0].plaNon;

					document.getElementById('basTotH_0_9').value = array[0].basTotH.toLocaleString();
					document.getElementById('appTotH_1_9').value = array[0].appTotH.toLocaleString();
					document.getElementById('advTotH_2_9').value = array[0].advTotH.toLocaleString();
					document.getElementById('majTotH_3_9').value = array[0].majTotH.toLocaleString();
					document.getElementById('opeTotH_4_9').value = array[0].opeTotH.toLocaleString();
					document.getElementById('plaTotH_5_9').value = array[0].plaTotH.toLocaleString();


                    //Total H
					array[0].totTotH = array[0].basTotH + array[0].appTotH + array[0].advTotH + array[0].majTotH + array[0].opeTotH + array[0].plaTotH;
					document.getElementById('totTotH_6_9').value = array[0].totTotH;


					array[0].basTot= array[0].basFed + array[0].basFun + array[0].basTotH;
					array[0].appTot= array[0].appFed + array[0].appFun + array[0].appTotH;
					array[0].advTot= array[0].advFed + array[0].advFun + array[0].advTotH;
					array[0].majTot= array[0].majFed + array[0].majFun + array[0].majTotH;
					array[0].opeTot= array[0].opeFed + array[0].opeFun + array[0].opeTotH;
					array[0].plaTot= array[0].plaFed + array[0].plaFun + array[0].plaTotH;
					array[0].totTot= array[0].basTot + array[0].appTot + array[0].advTot + array[0].majTot + array[0].opeTot + array[0].plaTot;

					document.getElementById('basTot_0_9').value = array[0].basTot.toLocaleString();
					document.getElementById('appTot_1_9').value = array[0].appTot.toLocaleString();
					document.getElementById('advTot_2_9').value = array[0].advTot.toLocaleString();
					document.getElementById('majTot_3_9').value = array[0].majTot.toLocaleString();
					document.getElementById('opeTot_4_9').value = array[0].opeTot.toLocaleString();
					document.getElementById('plaTot_5_9').value = array[0].plaTot.toLocaleString();
					document.getElementById('totTot_6_9').value = array[0].totTot.toLocaleString();
				}
				if(qId == 10)
				{
					//a
					array[0].totFed = array[0].basFed + array[0].appFed + array[0].advFed + array[0].majFed + array[0].opeFed + array[0].plaFed;
					//b
					array[0].totFun = array[0].basFun + array[0].appFun + array[0].advFun + array[0].majFun + array[0].opeFun + array[0].plaFun;
					//c
					array[0].totBus = array[0].basBus + array[0].appBus + array[0].advBus + array[0].majBus + array[0].opeBus + array[0].plaBus;
					//d
					array[0].totHig = array[0].basHig + array[0].appHig + array[0].advHig + array[0].majHig + array[0].opeHig + array[0].plaHig;
					//e
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].advOth + array[0].majOth + array[0].opeOth + array[0].plaOth;
					//f
					array[0].totSta = array[0].basSta + array[0].appSta + array[0].advSta + array[0].majSta + array[0].opeSta + array[0].plaSta;
					//g
					array[0].totNon = array[0].basNon + array[0].appNon + array[0].advNon + array[0].majNon + array[0].opeNon + array[0].plaNon;

					document.getElementById('totFed_6_10').value = array[0].totFed.toLocaleString();
					document.getElementById('totFun_6_10').value = array[0].totFun.toLocaleString();
					document.getElementById('totBus_6_10').value = array[0].totBus.toLocaleString();
					document.getElementById('totHig_6_10').value = array[0].totHig.toLocaleString();
					document.getElementById('totOth_6_10').value = array[0].totOth.toLocaleString();
					document.getElementById('totSta_6_10').value = array[0].totSta.toLocaleString();
					document.getElementById('totNon_6_10').value = array[0].totNon.toLocaleString();

					array[0].basTotH = array[0].basBus + array[0].basHig + array[0].basOth + array[0].basSta + array[0].basNon;
					array[0].appTotH = array[0].appBus + array[0].appHig + array[0].appOth + array[0].appSta + array[0].appNon;
					array[0].advTotH = array[0].advBus + array[0].advHig + array[0].advOth + array[0].advSta + array[0].advNon;
					array[0].majTotH = array[0].majBus + array[0].majHig + array[0].majOth + array[0].majSta + array[0].majNon;
					array[0].opeTotH = array[0].opeBus + array[0].opeHig + array[0].opeOth + array[0].opeSta + array[0].opeNon;
					array[0].plaTotH = array[0].plaBus + array[0].plaHig + array[0].plaOth + array[0].plaSta + array[0].plaNon;

					document.getElementById('basTotH_0_10').value = array[0].basTotH.toLocaleString();
					document.getElementById('appTotH_1_10').value = array[0].appTotH.toLocaleString();
					document.getElementById('advTotH_2_10').value = array[0].advTotH.toLocaleString();
					document.getElementById('majTotH_3_10').value = array[0].majTotH.toLocaleString();
					document.getElementById('opeTotH_4_10').value = array[0].opeTotH.toLocaleString();
					document.getElementById('plaTotH_5_10').value = array[0].plaTotH.toLocaleString();

					//h
					array[0].totTotH = array[0].basTotH + array[0].appTotH + array[0].advTotH + array[0].majTotH + array[0].opeTotH + array[0].plaTotH;
					document.getElementById('totTotH_6_10').value = array[0].totTotH;

					array[0].basTot = array[0].basFed + array[0].basFun + array[0].basTotH;
					array[0].appTot = array[0].appFed + array[0].appFun + array[0].appTotH;
					array[0].advTot = array[0].advFed + array[0].advFun + array[0].advTotH;
					array[0].majTot = array[0].majFed + array[0].majFun + array[0].majTotH;
					array[0].opeTot = array[0].opeFed + array[0].opeFun + array[0].opeTotH;
					array[0].plaTot = array[0].plaFed + array[0].plaFun + array[0].plaTotH;

					//i
					array[0].totTot = array[0].basTot + array[0].appTot + array[0].advTot + array[0].majTot + array[0].opeTot + array[0].plaTot;

					document.getElementById('basTot_0_10').value = array[0].basTot.toLocaleString();
					document.getElementById('appTot_1_10').value = array[0].appTot.toLocaleString();
					document.getElementById('advTot_2_10').value = array[0].advTot.toLocaleString();
					document.getElementById('majTot_3_10').value = array[0].majTot.toLocaleString();
					document.getElementById('opeTot_4_10').value = array[0].opeTot.toLocaleString();
					document.getElementById('plaTot_5_10').value = array[0].plaTot.toLocaleString();
					document.getElementById('totTot_6_10').value = array[0].totTot.toLocaleString();

				}
				if(qId == 11)
				{
					debugger;
					array[0].totCon = array[0].conCon + array[0].plaCon;
					array[0].totGra = array[0].conGra + array[0].plaGra;

					array[0].conTot = array[0].conCon + array[0].conGra;
					array[0].plaTot = array[0].plaCon + array[0].plaGra;

					array[0].totTot = array[0].conTot + array[0].plaTot;

					document.getElementById('totCon_2_11').value = array[0].totCon.toLocaleString();
					document.getElementById('totGra_2_11').value = array[0].totGra.toLocaleString();
					document.getElementById('conTot_0_11').value = array[0].conTot.toLocaleString();
					document.getElementById('plaTot_1_11').value = array[0].plaTot.toLocaleString();
					document.getElementById('totTot_2_11').value = array[0].totTot.toLocaleString();
				}
				if(qId == 12)
				{
					array[0].tot = array[0].con + array[0].pla;
					array[0].federalagencyid = "000007";
					array[1].tot = array[1].con + array[1].pla;
					array[1].federalagencyid = "000008";
					array[2].tot = array[2].con + array[2].pla;
					array[2].federalagencyid = "000047";
					array[3].tot = array[3].con + array[3].pla;
					array[3].federalagencyid = "000018";
					array[4].tot = array[4].con + array[4].pla;
					array[4].federalagencyid = "000019";
					array[5].tot = array[5].con + array[5].pla;
					array[5].federalagencyid = "000021";
					array[6].tot = array[6].con + array[6].pla;
					array[6].federalagencyid = "000035";
					array[7].tot = array[7].con + array[7].pla;
					array[7].federalagencyid = "000045";
					array[8].tot = array[8].con + array[8].pla;
					array[8].federalagencyid = "000046";
					array[9].tot = array[9].con + array[9].pla;
					array[9].federalagencyid = "000010";
					array[10].tot = array[10].con + array[10].pla;
					array[10].federalagencyid = "000011";
					array[11].tot = array[11].con + array[11].pla;
					array[11].federalagencyid = "000012";
					array[12].tot = array[12].con + array[12].pla;
					array[12].federalagencyid = "000013";
					array[13].tot = array[13].con + array[13].pla;
					array[13].federalagencyid = "000020";
					array[14].tot = array[14].con + array[14].pla;
					array[14].federalagencyid = "000015";
					array[15].tot = array[15].con + array[15].pla;
					array[15].federalagencyid = "000016";
					array[16].tot = array[16].con + array[16].pla;
					array[16].federalagencyid = "000017";
					array[17].tot = array[17].con + array[7].pla;
					array[17].federalagencyid = "000023";
					array[18].tot = array[18].con + array[18].pla;
					array[18].federalagencyid = "000022";
					array[19].tot = array[19].con + array[19].pla;
					array[19].federalagencyid = "000024";
					array[20].tot = array[20].con + array[20].pla;
					array[20].federalagencyid = "000048";
					array[21].tot = array[21].con + array[21].pla;
					array[21].federalagencyid = "000003";
					array[22].tot = array[22].con + array[22].pla;
					array[22].federalagencyid = "000004";
					array[23].tot = array[23].con + array[23].pla;
					array[23].federalagencyid = "000006";
					array[24].tot = array[24].con + array[24].pla;
					array[24].federalagencyid = "000025";
					array[25].tot = array[25].con + array[25].pla;
					array[25].federalagencyid = "000027";
					array[26].tot = array[26].con + array[26].pla;
					array[26].federalagencyid = "000030";
					array[27].tot = array[27].con + array[27].pla;
					array[27].federalagencyid = "000031";
					array[28].tot = array[28].con + array[28].pla;
					array[28].federalagency3d = "000033";
					array[29].tot = array[29].con + array[29].pla;
					array[29].federalagencyid = "000034";
					array[30].tot = array[30].con + array[30].pla;
					array[30].federalagencyid = "000049";
					array[31].tot = array[31].con + array[31].pla;
					array[31].federalagencyid = "000043";
					array[32].tot = array[32].con + array[32].pla;
					array[32].federalagencyid = "000037";
					array[33].tot = array[33].con + array[33].pla;
					array[33].federalagencyid = "000038";
					array[34].tot = array[34].con + array[34].pla;
					array[34].federalagencyid = "000039";
					array[35].tot = array[35].con + array[35].pla;
					array[35].federalagencyid = "000040";
					array[36].tot = array[36].con + array[36].pla;
					array[36].federalagencyid = "000036";
					array[37].tot = array[37].con + array[37].pla;
					array[37].federalagencyid = "000042";
					if (array[37].tot !== 0 && expval === "") {
						document.getElementById("span_Id").innerText = "Please enter explanation for Other department/agency, If incase not entered.";
					}	else {
						document.getElementById("span_Id").innerText = '';
					}
					var con = 0;
					var pla = 0;
					for (var i = 0; i < array.length; i++) {
						if (array[i].federalAgencyId != "000042") {
							con += array[i].con;
							pla += array[i].pla;
						}
					}
					array[37].con = con;
					array[37].pla = pla;
					array[37].tot = array[37].con + array[37].pla;
					array[37].federalagencyid = "000042";
				}
				if(qId == 13 || qId == 14 || qId == 15)
				{
					array[0].tot = array[0].fed + array[0].ffr + array[0].bus + array[0].edu +  array[0].oth + array[0].sta;
					array[0].stateId = "10061";
					array[1].tot = array[1].fed + array[1].ffr + array[1].bus + array[1].edu +  array[1].oth + array[1].sta;
					array[1].stateId = "11091";
					array[2].tot = array[2].fed + array[2].ffr + array[2].bus + array[2].edu +  array[2].oth + array[2].sta;
					array[2].stateId = "12081";
					array[3].tot = array[3].fed + array[3].ffr + array[3].bus + array[3].edu +  array[3].oth + array[3].sta;
					array[3].stateId = "13071";
					array[4].tot = array[4].fed + array[4].ffr + array[4].bus + array[4].edu +  array[4].oth + array[4].sta;
					array[4].stateId = "14092";
					array[5].tot = array[5].fed + array[5].ffr + array[5].bus + array[5].edu +  array[5].oth + array[5].sta;
					array[5].stateId = "15082";
					array[6].tot = array[6].fed + array[6].ffr + array[6].bus + array[6].edu +  array[6].oth + array[6].sta;
					array[6].stateId = "16011";
					array[7].tot = array[7].fed + array[7].ffr + array[7].bus + array[7].edu +  array[7].oth + array[7].sta;
					array[7].stateId = "17051";
					array[8].tot = array[8].fed + array[8].ffr + array[8].bus + array[8].edu +  array[8].oth + array[8].sta;
					array[8].stateId = "18052";
					array[9].tot = array[9].fed + array[9].ffr + array[9].bus + array[9].edu +  array[9].oth + array[9].sta;
					array[9].stateId = "19053";
					array[10].tot = array[10].fed + array[10].ffr + array[10].bus + array[10].edu +  array[10].oth + array[10].sta;
					array[10].stateId = "20054";
					array[11].tot = array[11].fed + array[11].ffr + array[11].bus + array[11].edu +  array[11].oth + array[11].sta;
					array[11].stateId = "21093";
					array[12].tot = array[12].fed + array[12].ffr + array[12].bus + array[12].edu +  array[12].oth + array[12].sta;
					array[12].stateId = "22083";
					array[13].tot = array[13].fed + array[13].ffr + array[13].bus + array[13].edu +  array[13].oth + array[13].sta;
					array[13].stateId = "23031";
					array[14].tot = array[14].fed + array[14].ffr + array[14].bus + array[14].edu +  array[14].oth + array[14].sta;
					array[14].stateId = "24032";
					array[15].tot = array[15].fed + array[15].ffr + array[15].bus + array[15].edu +  array[15].oth + array[15].sta;
					array[15].stateId = "25041";
					array[16].tot = array[16].fed + array[16].ffr + array[16].bus + array[16].edu +  array[16].oth + array[16].sta;
					array[16].stateId = "26042";
					array[17].tot = array[17].fed + array[17].ffr + array[17].bus + array[17].edu +  array[17].oth + array[17].sta;
					array[17].stateId = "27062";
					array[18].tot = array[18].fed + array[18].ffr + array[18].bus + array[18].edu +  array[18].oth + array[18].sta;
					array[18].stateId = "28072";
					array[19].tot = array[19].fed + array[19].ffr + array[19].bus + array[19].edu +  array[19].oth + array[19].sta;
					array[19].stateId = "29012";
					array[20].tot = array[20].fed + array[20].ffr + array[20].bus + array[20].edu +  array[20].oth + array[20].sta;
					array[20].stateId = "30055";
					array[21].tot = array[21].fed + array[21].ffr + array[21].bus + array[21].edu +  array[21].oth + array[21].sta;
					array[21].stateId = "31013";
					array[22].tot = array[22].fed + array[22].ffr + array[22].bus + array[22].edu +  array[22].oth + array[22].sta;
					array[22].stateId = "32033";
					array[23].tot = array[23].fed + array[23].ffr + array[23].bus + array[23].edu +  array[23].oth + array[23].sta;
					array[23].stateId = "33043";
					array[24].tot = array[24].fed + array[24].ffr + array[24].bus + array[24].edu +  array[24].oth + array[24].sta;
					array[24].stateId = "34063";
					array[25].tot = array[25].fed + array[25].ffr + array[25].bus + array[25].edu +  array[25].oth + array[25].sta;
					array[25].stateId = "35044";
					array[26].tot = array[26].fed + array[26].ffr + array[26].bus + array[26].edu +  array[26].oth + array[26].sta;
					array[26].stateId = "36084";
					array[27].tot = array[27].fed + array[27].ffr + array[27].bus + array[27].edu +  array[27].oth + array[27].sta;
					array[27].stateId = "37045";
					array[28].tot = array[28].fed + array[28].ffr + array[28].bus + array[28].edu +  array[28].oth + array[28].sta;
					array[28].stateId = "38085";
					array[29].tot = array[29].fed + array[29].ffr + array[29].bus + array[29].edu +  array[29].oth + array[29].sta;
					array[29].stateId = "39014";
					array[30].tot = array[30].fed + array[30].ffr + array[30].bus + array[30].edu +  array[30].oth + array[30].sta;
					array[30].stateId = "40021";
					array[31].tot = array[31].fed + array[31].ffr + array[31].bus + array[31].edu +  array[31].oth + array[31].sta;
					array[31].stateId = "41086";
					array[32].tot = array[32].fed + array[32].ffr + array[32].bus + array[32].edu +  array[32].oth + array[32].sta;
					array[32].stateId = "42022";
					array[33].tot = array[33].fed + array[33].ffr + array[33].bus + array[33].edu +  array[33].oth + array[33].sta;
					array[33].stateId = "43056";
					array[34].tot = array[34].fed + array[34].ffr + array[34].bus + array[34].edu +  array[34].oth + array[34].sta;
					array[34].stateId = "44046";
					array[35].tot = array[35].fed + array[35].ffr + array[35].bus + array[35].edu +  array[35].oth + array[35].sta;
					array[35].stateId = "45034";
					array[36].tot = array[36].fed + array[36].ffr + array[36].bus + array[36].edu +  array[36].oth + array[36].sta;
					array[36].stateId = "46073";
					array[37].tot = array[37].fed + array[37].ffr + array[37].bus + array[37].edu +  array[37].oth + array[37].sta;
					array[37].stateId = "47094";
					array[38].tot = array[38].fed + array[38].ffr + array[38].bus + array[38].edu +  array[38].oth + array[38].sta;
					array[38].stateId = "48023";
					array[39].tot = array[39].fed + array[39].ffr + array[39].bus + array[39].edu +  array[39].oth + array[39].sta;
					array[39].stateId = "49015";
					array[40].tot = array[40].fed + array[40].ffr + array[40].bus + array[40].edu +  array[40].oth + array[40].sta;
					array[40].stateId = "50057";
					array[41].tot = array[41].fed + array[41].ffr + array[41].bus + array[41].edu +  array[41].oth + array[41].sta;
					array[41].stateId = "51047";
					array[42].tot = array[42].fed + array[42].ffr + array[42].bus + array[42].edu +  array[42].oth + array[42].sta;
					array[42].stateId = "52064";
					array[43].tot = array[43].fed + array[43].ffr + array[43].bus + array[43].edu +  array[43].oth + array[43].sta;
					array[43].stateId = "53074";
					array[44].tot = array[44].fed + array[44].ffr + array[44].bus + array[44].edu +  array[44].oth + array[44].sta;
					array[44].stateId = "54087";
					array[45].tot = array[45].fed + array[45].ffr + array[45].bus + array[45].edu +  array[45].oth + array[45].sta;
					array[45].stateId = "55016";
					array[46].tot = array[46].fed + array[46].ffr + array[46].bus + array[46].edu +  array[46].oth + array[46].sta;
					array[46].stateId = "56058";
					array[47].tot = array[47].fed + array[47].ffr + array[47].bus + array[47].edu +  array[47].oth + array[47].sta;
					array[47].stateId = "57095";
					array[48].tot = array[48].fed + array[48].ffr + array[48].bus + array[48].edu +  array[48].oth + array[48].sta;
					array[48].stateId = "58059";
					array[49].tot = array[49].fed + array[49].ffr + array[49].bus + array[49].edu +  array[49].oth + array[49].sta;
					array[49].stateId = "59035";
					array[50].tot = array[50].fed + array[50].ffr + array[50].bus + array[50].edu +  array[50].oth + array[50].sta;
					array[50].stateId = "60088";
					for(var i=0; i< array.length; i++)
					{
						if(array[i].stateId == 70000)
						{
							array[51].tot = array[51].fed + array[51].ffr + array[51].bus + array[51].edu +  array[51].oth + array[51].sta;
							array[51].stateId = "70000";
						}
						if(array[i].stateId == 70001)
						{
							array[52].tot = array[52].fed + array[52].ffr + array[52].bus + array[52].edu +  array[52].oth + array[52].sta;
							array[52].stateId = "70001";
						}
						if(array[i].stateId == 70002)
						{
							array[53].tot = array[53].fed + array[53].ffr + array[53].bus + array[53].edu +  array[53].oth + array[53].sta;
							array[53].stateId = "70002";
						}
						if(array[i].stateId == 64100)
						{
							array[54].tot = array[54].fed + array[54].ffr + array[54].bus + array[54].edu +  array[54].oth + array[54].sta;
							array[54].stateId = "64100";
						}
						if(array[i].stateId== 70003)
						{
							array[55].tot = array[55].fed + array[55].ffr + array[55].bus + array[55].edu +  array[55].oth + array[55].sta;
							array[55].stateId = "70003";
						}
						if(array[i].stateId == 65100)
						{
							array[56].tot = array[56].fed + array[56].ffr + array[56].bus + array[56].edu +  array[56].oth + array[56].sta;
							array[56].stateId = "65100";
						}
						if(array[i].stateId==62200)
						{
							array[57].tot = array[57].fed + array[57].ffr + array[57].bus + array[57].edu +  array[57].oth + array[57].sta;
							array[57].stateId = "62200";
						}
						if(array[i].stateId==81000)
						{
							array[58].tot = array[58].fed + array[58].ffr + array[58].bus + array[58].edu +  array[58].oth + array[58].sta;
							array[58].stateId = "81000";
						}
					}
					var fed=0;
					var ffr=0;
					var bus=0;
					var edu=0;
					var oth=0;
					var sta=0;
					for(var i=0; i< array.length; i++)
					{
						if(array[i].stateId!=91000)
						{
							fed+=array[i].fed;
							ffr+=array[i].ffr;
							bus+=array[i].bus;
							edu+=array[i].edu;
							oth+=array[i].oth;
							sta+=array[i].sta;
						}
					}
					array[59].fed = fed;
					array[59].ffr = ffr;
					array[59].bus = bus;
					array[59].edu = edu;
					array[59].oth = oth;
					array[59].sta = sta;
					//TOTAL
					array[59].tot = array[59].fed + array[59].ffr + array[59].bus + array[59].edu +  array[59].oth + array[59].sta;
					array[59].stateId = "91000";

				}

				if(qId == 18 || qId == 19)
				{
					var bas=0;
					var app=0;
					var adv=0;
					var maj=0;
					var ope=0;
					var pla=0;
					for (var i = 0; i < array.length; i++)
					{
						if(qId == 18)
						{
							if(i != array.length-1)
							{
								array[i].tot = array[i].bas + array[i].app + array[i].adv + array[i].maj +  array[i].ope + array[i].pla;
								bas+=array[i].bas;
								app+=array[i].app;
								adv+=array[i].adv;
								maj+=array[i].maj;
								ope+=array[i].ope;
								pla+=array[i].pla;
							}
							switch(i)
							{
								case 0:
									array[i].ffrdcId="930042";
									break;
								case 1:
									array[i].ffrdcId="920011";
									break;
								case 2:
									array[i].ffrdcId="920012";
									break;
								case 3:
									array[i].ffrdcId="930803";
									break;
								case 4:
									array[i].ffrdcId="930013";
									break;
								case 5:
									array[i].ffrdcId="930074";
									break;
								case 6:
									array[i].ffrdcId="930100";
									break;
								case 7:
									array[i].ffrdcId="930075";
									break;
								case 8:
									array[i].ffrdcId="930038";
									break;
								case 9:
									array[i].ffrdcId="930073";
									break;
								case 10:
									array[i].ffrdcId="931100";
									break;
								case 11:
									array[i].ffrdcId="920064";
									break;
								case 12:
									array[i].ffrdcId="910002";
									break;
								case 13:
									array[i].ffrdcId="920031";
									break;
								case 14:
									array[i].ffrdcId="930905";
									break;
								case 15:
									array[i].ffrdcId="930904";
									break;
								case 16:
									array[i].ffrdcId="910005";
									break;
								case 17:
									array[i].ffrdcId="920024";
									break;
								case 18:
									array[i].ffrdcId="920016";
									break;
								case 19:
									array[i].ffrdcId="910012";
									break;
								case 20:
									array[i].ffrdcId="920010";
									break;
								case 21:
									array[i].ffrdcId="910011";
									break;
								case 22:
									array[i].ffrdcId="930903";
									break;
								case 23:
									array[i].ffrdcId="920027";
									break;
								case 24:
									array[i].ffrdcId="931110";
									break;
								case 25:
									array[i].ffrdcId="930801";
									break;
								case 26:
									array[i].ffrdcId="920030";
									break;
								case 27:
									array[i].ffrdcId="930066";
									break;
								case 28:
									array[i].ffrdcId="930047";
									break;
								case 29:
									array[i].ffrdcId="923900";
									break;
								case 30:
									array[i].ffrdcId="923888";
									break;
								case 31:
									array[i].ffrdcId="930004";
									break;
								case 32:
									array[i].ffrdcId="930885";
									break;
								case 33:
									array[i].ffrdcId="920020";
									break;
								case 34:
									array[i].ffrdcId="930065";
									break;
								case 35:
									array[i].ffrdcId="910009";
									break;
								case 36:
									array[i].ffrdcId="910010";
									break;
								case 37:
									array[i].ffrdcId="930900";
									break;
								case 38:
									array[i].ffrdcId="920017";
									break;
								case 39:
									array[i].ffrdcId="920804";
									break;
								case 40:
									array[i].ffrdcId="930041";
									break;
								case 41:
									array[i].ffrdcId="920066";
									break;
								case 42:
									array[i].tot = array[i].bas + array[i].app + array[i].adv + array[i].maj +  array[i].ope + array[i].pla;
									array[i].ffrdcId="940000";
									break;
							}
						}
						if(qId == 19)
						{
							if(i != array.length-1)
							{
								array[i].tot = array[i].bas + array[i].app + array[i].adv + array[i].maj +  array[i].ope + array[i].pla;
								bas+=array[i].bas;
								app+=array[i].app;
								adv+=array[i].adv;
								maj+=array[i].maj;
								ope+=array[i].ope;
								pla+=array[i].pla;
							}
							switch(i)
							{
								case 0:
									array[i].uarcid="1";
									break;
								case 1:
									array[i].uarcid="16";
									break;
								case 2:
									array[i].uarcid="2";
									break;
								case 3:
									array[i].uarcid="3";
									break;
								case 4:
									array[i].uarcid="4";
									break;
								case 5:
									array[i].uarcid="5";
									break;
								case 6:
									array[i].uarcid="6";
									break;
								case 7:
									array[i].uarcid="7";
									break;
								case 8:
									array[i].uarcid="8";
									break;
								case 9:
									array[i].uarcid="9";
									break;
								case 10:
									array[i].uarcid="10";
									break;
								case 11:
									array[i].uarcid="11";
									break;
								case 12:
									array[i].uarcid="12";
									break;
								case 13:
									array[i].uarcid="13";
									break;
								case 14:
										array[i].uarcid="14";
										break;
								case 15:
									array[i].bas = bas;
									array[i].app = app;
									array[i].adv = adv;
									array[i].maj = maj;
									array[i].ope = ope;
									array[i].pla = pla;
									array[i].tot = array[i].bas + array[i].app + array[i].adv + array[i].maj +  array[i].ope + array[i].pla;
									array[i].uarcid="15";
									break;
							}
						}
					}
				}
				if(qId == 20)
				{
					var res=0;
					var adv=0;
					var maj=0;
					var ope=0;
					var pla=0;
					var sefel=0;
					var oth=0;
					var fac=0;

					var surveyid=0;
					var createBy=null;
					var createDate=null;
					for (var i = 0; i < array.length; i++)
					{
						if(array[i].orgCod != '000001')
						{
							res+=array[i].res;
							adv+=array[i].adv;
							maj+=array[i].maj;
							ope+=array[i].ope;
							pla+=array[i].pla;
							sefel+=array[i].seFel;
							fac+=array[i].fac;
							oth+=array[i].oth;
							surveyid=array[i].surveyId;
							createBy=array[i].createBy;
							createDate=array[i].createDate;
						}
					}
					for (var i = 0; i < array.length; i++)
					{
						if(array[i].orgCod == '000001')
						{
							array[i].res=res;
							array[i].adv=adv;
							array[i].maj=maj;
							array[i].ope=ope;
							array[i].pla=pla;
							array[i].seFel=sefel;
							array[i].fac=fac;
							array[i].oth=oth;
						}
					}
				}
				if(qId == 21)
				{
					var res=0;
					var adv=0;
					var maj=0;
					var ope=0;
					var pla=0;
					var surveyid=0;
					var createBy=null;
					var createDate=null;
					for (var i = 0; i < array.length; i++)
					{
						if(array[i].orgCod != '000001')
						{
							res+=array[i].res;
							adv+=array[i].adv;
							maj+=array[i].maj;
							ope+=array[i].ope;
							pla+=array[i].pla;
							surveyid=array[i].surveyId;
							createBy=array[i].createBy;
							createDate=array[i].createDate;
						}
					}
					for (var i = 0; i < array.length; i++)
					{
						if(array[i].orgCod == '000001')
						{
							array[i].res=res;
							array[i].adv=adv;
							array[i].maj=maj;
							array[i].ope=ope;
							array[i].pla=pla;
						}
					}
				}
			}

        context.commit('setIsSaving', { isSaving: true });
				answerService.saveAnswer(qId, array, true).then(function (response) {
					if (response && CONSTANTS.HTTP.NO_CONTENT === response.status) { // 204 - Success No Content
						// Trigger loading this questions validation messages
						context.dispatch('validation/loadSurveyValidationMessages');
						// Trigger loading all question statuses
						context.dispatch('validation/loadQuestionStatuses');
						context.commit('setIsSaving', { isSaving: false });
						context.commit('setIsLoading', { isLoading: false });
						context.commit('setLastSaved', { lastSavedTimeStamp: utilityService.getTimeStamp() });
						context.commit('setquestionId',{ questionId: qId});
					}
				})
				.catch(function (e) {
					context.commit('setIsSaving', { isSaving: false });
					context.commit('setIsLoading', { isLoading: false });
					if(!isStandardSurvey && qId == 11)
						context.commit('setLastSaved', { lastSavedTimeStamp: 'An error occured, Please try saving Queston 1 then try again saving Question 11, may resolve the problem' });
					else if(qId==10)
						context.commit('setLastSaved', { lastSavedTimeStamp: 'An error occured, Please try saving Queston 9 then try again saving Question 10, may resolve the problem' });
					else
						context.commit('setLastSaved', { lastSavedTimeStamp: 'An error occured, Please try again. "Save / Home / Close or Refresh or Clear the cache from the brower " may resolve the problem' });
					console.error(e);
					throw e;
				});
	    },
		loadSurveyType(context,{ isStandardSurvey })
		{
			context.commit('setIsSurveyType', { isStandardSurvey: isStandardSurvey });
		}
	},
	getters: {
		answersArray: (state) => {
			return state.answers;
		},
		isSaving: (state) => {
			return state.isSaving;
		},
		lastSavedTimeStamp: (state) => {
			return state.lastSavedTimeStamp;
		},
		count: (state) => {
			return state.count;
		},
		isLoading: (state) => {
			return state.isLoading;
		},
		isSurveyType: (state) => {
			return state.standardSurvey;
		},
		questionId: (state)=>{
			return state.questionId;
		},
	}
}
export default new Vuex.Store({
	modules: {
		// answers: nonDoDSurvey,
		// metadata: meta,
		survey: survey,
		validation: validation
	}
});
